<template>
  <section v-if="currentClaim && currentClaim.uid">
    <b-message
      v-if="isAllNonCar"
      size="is-small"
      :title="$t('detail_view.all_non_car_title')"
      type="is-warning"
      has-icon
      aria-close-label="Close message"
    >
      {{ $t('detail_view.all_non_car_message') }}
    </b-message>
    <b-loading :is-full-page="true" :active.sync="isProcessing">
      <div class="columns is-centered">
        <div class="column is-12 has-text-centered gcasia">
          <p>
            <b-icon pack="fas" icon="sync-alt" size="is-large" custom-class="fa-spin" />
          </p>
          <h2 class="title is-3 is-size-5" style="margin-top: 10px;">
            {{ $t(`loder_text.${loaderText}`) }}
          </h2>
          <!-- <div v-if="showLink && processPercent !== null" :key="progressRefreshKey" class="demo-wrapper html5-progress-bar">
            <div class="progress-bar-wrapper">
              <div> <span class="progress-value">{{ processPercent }}%</span></div>
              <progress id="progressbar" :value="processPercent" max="100" />
            </div>
          </div> -->
          <router-link
            v-if="showLink"
            :to="{name: 'ClaimList'}"
            class="Home_link"
          >
            {{ $t('confirmation_message.Return to claims list') }}
          </router-link>
        </div>
      </div>
    </b-loading>
    <div class="columns" style="margin-bottom:-5px;">
      <div class="column is-12 ai-table">
        <component
          :is="pageComponents.vehicleInfo"
          :key="claimInfoRefreshKey"
          :currency="$cgiSettings.currency"
          :claim-info="claimInfo"
        />
      </div>
    </div>
    <section>
      <section>
        <div class>
          <div class="columns">
            <div class="column is-8 gcasiagaptabs">
              <!-- :key="currentClaim.processing_completed_at" -->
              <b-tabs
                :key="currentClaim.processing_completed_at"
                v-model="selectedTab"
                type="is-toggle"
                :animated="false"
              >
                <!--Summary-->
                <b-tab-item>
                  <template slot="header" @click="getTabStatus">
                    <span @click="getTabStatus">{{ $t('detail_view.summary') }}</span>
                  </template>
                  <div class="columns">
                    <div v-if="showIllustration" class="column">
                      <div class="card equal-height">
                        <div class="card-header">
                          <div class="card-header-title">
                            {{ $t('detail_view.summary') }}
                          </div>
                          <div class="move-right">
                            <div class="block">
                              <b-taglist attached style="margin-top: 9px;margin-right: 8px;">
                                <b-tag type="is-white ">
                                  {{ $t('detail_view.severity') }} :
                                </b-tag>
                                <b-tag type="bg-green ">
                                  {{ $t('detail_view.severity_low') }}
                                </b-tag>
                                <b-tag type="bg-orange ">
                                  {{ $t('detail_view.severity_medium') }}
                                </b-tag>
                                <b-tag type="bg-red ">
                                  {{ $t('detail_view.severity_high') }}
                                </b-tag>
                              </b-taglist>
                            </div>
                          </div>
                        </div>
                        <div class="card-content GC-min-height">
                          <div style="padding: 1rem;">
                            <component
                              :is="pageComponents.illustration"
                              v-if="showIllustration"
                              :key="illustrationRefreshKey"
                              :images="getClaimImages"
                              :damage-summary="getVehicleOperations"
                              :body-type="getBodyType()"
                            />
                            <!-- :key="illustrationKey" -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="column is-8">
                      <!-- <component
                        :is="pageComponents.damageViewer"
                        :key="currentImageUrl"
                        :images="imgData"
                        :annotate-mode="annotateMode"
                        :rr-decision="currentClaim.rr_prediction"
                        :image-index="imageIndex"
                        :started-at="currentClaim.started_at"
                        @save-annotation="saveAnnotation"
                      /> -->
                    </div>
                  </div>
                </b-tab-item>

                <!--Other Tabs-->

                <b-tab-item
                  v-for="tabitem in tabData"
                  :key="tabitem.id + tabRefreshKey"
                  :disabled="currentClaim.processing_completed_at && currentClaim.results.vehicle_operations === null ? true : false"
                >
                  <template slot="header" @click="onPositionTabChanged">
                    <progress
                      class="progress is-pulled-left position-progress"
                      :class="getSeverityValue(tabitem.id)"
                      value="100"
                      max="100"
                    >
                      15%
                    </progress>
                    <span @click="onPositionTabChanged">{{ $t(`detail_view.${tabitem.label}`) }}</span>
                  </template>
                  <div :key="selectedTab + imageIndexKey" class="columns">
                    <div
                      :class="showPositionParts ? 'column is-12 ' : 'column is-12 min-content-height'"
                    >
                      <component
                        :is="pageComponents.damageViewer"
                        :key="damageViewerRefreshKey"
                        :images="tabitem.images"
                        :show-parts="showPositionParts"
                        :annotate-mode="annotateMode"
                        :rr-decision="currentClaim.results.vehicle_operations"
                        :image-index="imageIndex"
                        :processing-completed="currentClaim.processing_completed_at ? true : false"
                        :started-at="currentClaim.processing_started_at"
                        :parts-mapping="getPartsMapping"
                        :goto-airbag="gotoAirbag"
                        :body-type="getBodyType()"
                        :bodytype-parts="getPositionWiseParts"
                        :glass-parts="glassParts"
                        @save-annotation="saveAnnotation"
                      />
                    </div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>
            <div class="column is-4" style="margin-top:0px">
              <div style="height:41px">
                <component
                  :is="pageComponents.actionBar"
                  :key="actionBarRefreshKey"
                  :claim-images="claimImages"
                  :claim-videos="claimVideos"
                  :enable-reprocessing="enableReprocessing"
                  :claim-versions="claimVersions"
                  :show-resubmit-button="showResubmitButton"
                  :claim-info="pdfData"
                  :action-bar-settings="$cgiSettings.detailsForm.actionBar"
                  @submitClaimFeedback="submitClaimFeedback"
                  @onShowEstimationReport="showEstimationReport"
                  @approveClaim="approveClaim"
                  @syncToChordys="syncToChordys"
                  @printEstimate="print"
                  @reProcessClaim="reProcessClaim"
                  @submitForReprocessing="submitForReprocessing"
                  @fetchSelectedClaim="fetchSelectedClaim"
                  @showReassignPosition="showReassignPosition"
                  @editClaim="editClaim"
                />
              </div>
              <div v-show="$cgiSettings.showParts">
                <!-- @onPartSelected="selected" -->
                <component
                  :is="pageComponents.partSummary"
                  v-if="damageSummary"
                  :key="refreshSummaryKey"
                  :damage-summary="damageSummary"
                  :price-info="priceInfo"
                  :part-section="$cgiSettings.detailsForm.partSection"
                  :internal-part-list="internalPartList"
                  :claim-id="currentClaim.id"
                  :part-gst-percent="partGstPercent"
                  :labour-tax-percent="labourTaxPercent"
                  :paint-tax-percent="paintTaxPercent"
                  :show-tooltip="showTooltip"
                  @partPricingUpdated="partPricingUpdated"
                  @onUpdateMainPartDecision="updateMainPartDecision"
                  @onPartSelected="selected"
                  @onAddSelected="addSelected"
                  @bulkPartPricingUpdated="bulkPartPricingUpdated"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
    <b-modal :active.sync="isEstimationReportActive" class="has-modal-card estimate-card">
      <div class="modal-card" style="width: auto">
        <div class="modal-card-body">
          <component
            :is="pageComponents.estimationReport"
            v-if="currentClaim.results && currentClaim.results.part_pricing"
            :estimate-formatted-data="estimateFormattedData"
            @download="downloadPdf()"
            @downloadExcel="downloadExcel()"
          />
        </div>
      </div>
    </b-modal>
    <b-modal :key="refreshRepositionTabData" :active.sync="isRepositionTabActive" :can-cancel="false"
             class="has-modal-card estimate-card refreshReposition-tab"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('photo_gallery.photo_gallery') }} <span class="btn-all-data">
              <b-tooltip position="is-bottom" :label="$t('photo_gallery.Upload Images')" size="is-small" type=" is-primary"
                         style="background: transparent;"
              >
                <b-upload v-model="selectedFiles" multiple accept=".jpg,.jpeg,.png" :native="true" @input="validate">
                  <a class="button is-info add-upload">
                    <b-icon pack="fas" icon="plus" type=" is-primary" size="is-small" />
                  </a>
                </b-upload>
              </b-tooltip>
              <!-- <b-tooltip position="is-bottom" :label="$t('detail_view.action_bar_save_close')" size="is-small">
                    <b-button :disabled="disableSaveReprocess" class="button save-add-upload " size="is-small" @click="isRepositionTabActive = false">Save </b-button>
                  </b-tooltip> -->
              <b-tooltip position="is-bottom" :label="$t('detail_view.action_bar_reprocess')" size="is-small">
                <b-button :disabled="disableSaveReprocess" class="button save-add-upload " size="is-small"
                          @click.prevent="processReposition()"
                >
                  <b-icon pack="fas" icon="redo" type=" is-primary" size="is-small" />
                </b-button>
              </b-tooltip>
              <div class="is-pulled-right" style="margin-top: -1px;margin-right: 5px;margin-left: 9px;">
                <b-tooltip position="is-bottom" :label="$t('detail_view.action_bar_close')" size="is-small">
                  <a class="button is-danger" @click="checkAndClose()"><span class="icon"><i
                    class="fas fa-times"
                  /></span></a>
                </b-tooltip>
              </diV>

            </span>
          </p>
        </header>
        <div class="modal-card-body">
          <section>
            <div class>
              <div class="columns">
                <div class="column is-12">
                  <!-- :key="currentClaim.processing_completed_at" -->
                  <b-tabs :key="currentClaim.processing_completed_at" v-model="selectedPositionTab" type="is-toggle"
                          :animated="false"
                  >
                    <!--Other Tabs-->
                    <b-tab-item v-for="tabitem in rePositionImageData" :key="tabitem.id + tabRefreshKey"
                                :disabled="currentClaim.processing_completed_at && currentClaim.results.vehicle_operations === null ? true : false"
                    >
                      <!-- <template slot="header" @click="onPositionTabChanged">
                            <span @click="onPositionTabChanged">{{ $t(`detail_view.${tabitem.label}`) }}</span>
                          </template> -->
                      <template slot="header">
                        <span>{{ $t(`detail_view.${tabitem.label}`) }}</span>
                      </template>
                      <div :key="selectedPositionTab + imageIndexKey" class="columns">
                        <div :class="showPositionParts ? 'column is-12 ' : 'column is-12 min-content-height'">
                          <component :is="pageComponents.reassignPosition" :images="tabitem.images"
                                     :image-index="imageIndex" :processing-completed="currentClaim.processing_completed_at ? true : false"
                                     :started-at="currentClaim.processing_started_at" :disable-save-reprocess="disableSaveReprocess"
                                     @imagePositionChange="imagePositionChange" @removeImage="removeImage"
                                     @checkboxChange="checkboxChange"
                          />
                        </div>
                      </div>
                    </b-tab-item>
                  </b-tabs>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </b-modal>
    <b-modal :active.sync="showPrintReportWithImageModal" has-modal-card :on-cancel="closePrintPopUp">
      <div class="modal-card" style="width: 320px">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t(`detail_view.confirm_print_images`) }}
          </p>
        </header>
        <section class="modal-card-body">
          <div class="change-flow">
            <b-field>
              <b-checkbox v-model="isWithImage" class=" " size="is-medium">
                {{ $t(`detail_view.include_images`) }}?
              </b-checkbox>
            </b-field>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closePrintPopUp">
            {{ $t(`detail_view.close`) }}
          </button>
          <button class="button is-primary" @click="preparePrintData">
            {{ $t(`detail_view.print`) }}
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
import { saveAs } from 'file-saver';
import axios from 'axios';

const _ = require('lodash');
const clone = require('lodash.clone');
const Excel = require('exceljs');
const printJS = require('print-js');
// const claimDt = require('../../../data/claim_details.json');
let defaultTabData = require('../../../data/defaultTabData.json');
const defaultPartObject = require('../../../data/defaultPartObject.json');
const glassParts = require('../../../data/glassParts.json');
// const positionWiseParts = require('../../../data/position_parts.json');
const bodyTypeBasedParts = require('../../../data/bodytype_based_parts.json');

export default {
  name: 'ClaimDetail',
  data() {
    return {
      currentClaim: {},

      // #region [Loader Properties]
      showLink: true,
      isProcessing: true,
      processPercent: null,
      progressRefreshKey: null,
      loaderText: 'Processing Claim Request',
      // #endregion

      // #region [Page Components]
      pageComponents: {
        vehicleInfo: this.$cgiComponents.vehicleInfo,
        aiAnalysis: this.$cgiComponents.aiAnalysis,
        aiDetails: this.$cgiComponents.aiDetails,
        claimFeedback: this.$cgiComponents.claimFeedback,
        partSummary: this.$cgiComponents.partSummary,
        illustration: this.$cgiComponents.illustration,
        damageViewer: this.$cgiComponents.damageViewer,
        estimationReport: this.$cgiComponents.estimationReport,
        actionBar: this.$cgiComponents.actionBar,
        reassignPosition: this.$cgiComponents.reassignPosition,
      },
      // #endregion

      // #region [Claim Info]
      claimInfo: {},
      claimInfoRefreshKey: null,
      // #endregion

      // #region [Gauge : Damage Confidence]
      damageConfidenceDecision: { none: 15, repair: 50, replace: 85 },
      // #endregion

      // #region [Tab View (Illustration, Positions, Other)]
      showIllustration: true,
      selectedTab: 0,
      imageIndex: 0,
      cloneDefultTabs: clone(defaultTabData),
      imageIndexKey: 0,
      showPositionParts: false,
      annotateMode: false,
      // #endregion

      // #region [Parts Summary]
      damagePartsCount: 0,
      languageCode: 'en',
      enableEditOem: this.$cgiSettings.detailsForm.partSection.enableOEM,
      enableInternalPartsEdit: this.$cgiSettings.detailsForm.partSection.enableInternalPart,
      selectedPartName: null,
      // priceInfo: {},
      // #endregion

      // #region [Estimation Report]
      estimationMaskedImages: [],
      isEstimationReportActive: false,
      estimateTemplateId: this.$cgiSettings.templateId,
      showEstimationSummaryOnly: false,
      showNote: false,
      clientLogo: this.$cgiSettings.logoUrl,
      isLandscape: Boolean(this.$cgiSettings.detailsForm.fullEstimate.isLandscape),
      partGstPercent: this.$cgiSettings.detailsForm.partSection.gstPercent,
      labourTaxPercent: this.$cgiSettings.detailsForm.partSection.labourTaxPercent,
      paintTaxPercent: this.$cgiSettings.detailsForm.partSection.paintTaxPercent,
      addMissingPart: this.$cgiSettings.detailsForm.partSection.addMissingPart || false,
      // #endregion
      selectedPartEdit: {},
      actionBarRefreshKey: null,
      illustrationRefreshKey: null,
      damageViewerRefreshKey: null,
      estimationReportRefreshKey: null,
      tabRefreshKey: null,
      fetchedClaimId: null,
      gotoAirbag: false,
      bodyTypeBasedParts,
      pickupTruckEnabled: this.$cgiSettings.pickupTruckEnabled,
      miniVanEnabled: this.$cgiSettings.miniVanEnabled,
      glassParts,
      // Reposition
      rePositionImageData: [],
      isRepositionTabActive: false,
      refreshSummaryKey: null,
      selectedPositionTab: 0,
      disableSaveReprocess: true,
      refreshRepositionTabData: null,
      selectedFiles: [],
      imageTempData: [],
      cloneRePositionImageData: [],
      uploadedNewImages: [],
      sequence: ['front', 'front_left', 'left', 'rear_left', 'rear', 'rear_right', 'right', 'front_right', 'others'],
      estimateFormattedData: {},
      excludeAuxilaryPartPrice: this.$cgiComponents.excludeAuxilaryPartsPrice ? this.$cgiComponents.excludeAuxilaryPartsPrice : false,
      timeZoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isWithImage: true,
      showPrintReportWithImageModal: false,
      isPrintReportImageModalEnable: (this.$cgiComponents.detailsForm && this.$cgiComponents.detailsForm.actionBar && this.$cgiComponents.detailsForm.actionBar.enablePrintReportImageModal) ? this.$cgiComponents.detailsForm.actionBar.enablePrintReportImageModal : false,
      showTooltip: null,
    };
  },
  computed: {
    isAllNonCar() {
      if (this.isClaimProcessingCompleted) {
        const { results } = this.currentClaim;
        if (results && results.images && results.images.length > 0) {
          const allCarPartialImages = results.images.filter((x) => (x.results && x.results.is_car === 'car') || (x.results && x.results.is_car === 'partial_car'));
          if (allCarPartialImages.length === 0) {
            return true;
          }
          return false;
        }
        return true;
      }
      return false;
    },

    isClaimProcessingCompleted() {
      if (this.currentClaim && this.currentClaim.processing_completed_at && this.currentClaim.processing_completed_at !== null) {
        return true;
      }
      return false;
    },

    repairabilityStatus() {
      if (this.isClaimProcessingCompleted) {
        const { results } = this.currentClaim;
        if (results && results.repairability_status) {
          return results.repairability_status;
        }
        return null;
      }
      return 'Processing claim...';
    },
    getTotalGrossRepairEstimate: {
      cache: false,
      get() {
        const price = this.priceInfo;
        if (this.isClaimProcessingCompleted && this.currentClaim.results && this.currentClaim.results.part_pricing && price) {
          const { summary } = this.currentClaim.results.part_pricing;
          const totalPartPrice = summary.meta.total_part_with_gst ? summary.meta.total_part_with_gst : 0;
          const totalLaborPrice = summary.meta.total_labour_with_gst ? summary.meta.total_labour_with_gst : 0;
          const totalPaintPrice = summary.meta.total_paint_with_gst ? summary.meta.total_paint_with_gst : 0;

          const totalAuxiliaryPartPrice = summary.meta.aux_parts_total_part_with_gst ? summary.meta.aux_parts_total_part_with_gst : 0;
          const totalAuxiliaryLaborPrice = summary.meta.aux_parts_total_labour_with_gst ? summary.meta.aux_parts_total_labour_with_gst : 0;
          const totalAuxiliaryPaintPrice = summary.meta.aux_parts_total_paint_with_gst ? summary.meta.aux_parts_total_paint_with_gst : 0;

          const totalInternalPartPrice = summary.meta.int_parts_total_part_with_gst ? summary.meta.int_parts_total_part_with_gst : 0;
          const totalInternalLaborPrice = summary.meta.int_parts_total_labour_with_gst ? summary.meta.int_parts_total_labour_with_gst : 0;
          const totalInternalPaintPrice = summary.meta.int_parts_total_paint_with_gst ? summary.meta.int_parts_total_paint_with_gst : 0;
          const compulsoryExcess = this.currentClaim.compulsory_excess || 0;

          if (this.addMissingPart && this.currentClaim.results.part_pricing.additionalParts && this.currentClaim.results.part_pricing.additionalParts.parts && this.currentClaim.results.part_pricing.additionalParts.parts.length > 0) {
            const { additionalParts } = this.currentClaim.results.part_pricing;
            const totalAdditionalPartPrice = additionalParts.summary.total_part_with_gst ? additionalParts.summary.total_part_with_gst : 0;
            const totalAdditionalLaborPrice = additionalParts.summary.total_labour_with_gst ? additionalParts.summary.total_labour_with_gst : 0;
            const totalAdditionalPaintPrice = additionalParts.summary.total_paint_with_gst ? additionalParts.summary.total_paint_with_gst : 0;

            return parseFloat(totalPartPrice + totalLaborPrice + totalPaintPrice
              + totalAuxiliaryPartPrice + totalAuxiliaryLaborPrice + totalAuxiliaryPaintPrice
              + totalInternalPartPrice + totalInternalLaborPrice + totalInternalPaintPrice
              + totalAdditionalPartPrice + totalAdditionalLaborPrice + totalAdditionalPaintPrice - compulsoryExcess).toFixed(2);
          }

          return parseFloat(totalPartPrice + totalLaborPrice + totalPaintPrice
            + totalAuxiliaryPartPrice + totalAuxiliaryLaborPrice + totalAuxiliaryPaintPrice
            + totalInternalPartPrice + totalInternalLaborPrice + totalInternalPaintPrice - compulsoryExcess).toFixed(2);
        }
        return 0;
      },
    },

    getDamageMeterValue() {
      if (this.isClaimProcessingCompleted && this.currentClaim.results) {
        // eslint-disable-next-line camelcase
        const { vehicle_operations } = this.currentClaim.results;
        // eslint-disable-next-line camelcase
        if (vehicle_operations && vehicle_operations.length > 0) {
          const replacePartExist = vehicle_operations.find((x) => x.decision === 'replace');
          if (replacePartExist) { return this.damageConfidenceDecision.replace; }
          const repairPartExist = vehicle_operations.find((x) => x.decision === 'repair');
          if (repairPartExist) { return this.damageConfidenceDecision.repair; }
          return this.damageConfidenceDecision.none;
        }
        return this.damageConfidenceDecision.none;
      }
      return this.damageConfidenceDecision.none;
    },
    getClaimImages() {
      const { results } = this.currentClaim;
      if (results && results.images && results.images.length > 0) {
        const allCarPartialImages = results.images.filter((x) => (x.results && x.results.is_car === 'car') || (x.results && x.results.is_car === 'partial_car'));
        if (allCarPartialImages.length > 0) {
          const mappedImages = allCarPartialImages.map((x) => ({
            id: x.id,
            url: x.url,
            image_key: x.key || null,
            results: {
              is_car: x.results.is_car || null,
              position: x.results.position || null,
              severity: x.results.severity || null,
              parts: x.results.parts || null,
            },
          }));
          return mappedImages;
        }
        return [];
      }
      return [];
    },
    getVehicleOperations() {
      const { results } = this.currentClaim;
      if (results && results.vehicle_operations && results.vehicle_operations.length > 0) {
        const mappedDamages = results.vehicle_operations.map((x) => ({
          part_name: x.part_name,
          name: x.name,
          decision: x.decision,
        }));
        return mappedDamages;
      }
      return [];
    },

    tabData() {
      if (
        this.currentClaim
        && this.currentClaim.uid
        && this.currentClaim.results
        && this.currentClaim.results.images
        && this.currentClaim.results.images.length > 0
      ) {
        // defaultTabData = this.cloneDefultTabs;
        defaultTabData = [{
          id: 'front', label: 'Front', images: [], isVisible: false,
        }, {
          id: 'front_left', label: 'Front Left', images: [], isVisible: false,
        }, {
          id: 'front_right', label: 'Front Right', images: [], isVisible: false,
        }, {
          id: 'left', label: 'Left', images: [], isVisible: false,
        }, {
          id: 'right', label: 'Right', images: [], isVisible: false,
        }, {
          id: 'rear_left', label: 'Rear Left', images: [], isVisible: false,
        }, {
          id: 'rear_right', label: 'Rear Right', images: [], isVisible: false,
        }, {
          id: 'rear', label: 'Rear', images: [], isVisible: false,
        }, {
          id: 'others', label: 'Others', images: [], isVisible: false,
        }];
        const { results } = this.currentClaim;
        results.images.forEach((oneImage) => {
          if (oneImage && oneImage.results) {
            if (
              oneImage.results.is_car
              && oneImage.results.is_car !== 'non_car'
              && oneImage.results.position
            ) {
              const fetchedTab = defaultTabData.find(
                (pc) => pc.id === oneImage.results.position,
              );
              fetchedTab.isVisible = true;
              // if (this.currentClaim.processing_completed_at) { fetchedTab.images = []; }
              if (!_.find(fetchedTab.images, { id: oneImage.id })) {
                fetchedTab.images.push({
                  id: oneImage.id,
                  url: oneImage.url,
                  damages: this.getPartDamages(oneImage.results),
                  damageMask: oneImage.results.damage_masked_image || oneImage.url,
                  position: oneImage.results.position,
                  features: this.getImageFeatures(oneImage.results.part_damages || []),
                  exifInfo: oneImage.results.exif,
                  picSubcategory: oneImage.results.subcategory,
                });
              }
            } else {
              const fetchedTab = defaultTabData.find((pc) => pc.id === 'others');
              fetchedTab.isVisible = true;
              if (!_.find(fetchedTab.images, { id: oneImage.id })) {
                fetchedTab.images.push({
                  id: oneImage.id,
                  url: oneImage.url,
                  damages: this.getPartDamages(oneImage.results),
                  damageMask: oneImage.results.damage_masked_image || oneImage.url,
                  position: oneImage.results.position,
                  features: this.getNonCarImageFeatures(oneImage.results.part_damages || []),
                  isAirbag: oneImage.results.subcategory === 'airbag',
                  exifInfo: oneImage.results.exif,
                  picSubcategory: oneImage.results.subcategory,
                });
              }
            }

            // remove duplicates from other-tab
            const otherTab = defaultTabData.find((pc) => pc.id === 'others');
            if (
              oneImage.results.position !== 'others'
              && oneImage.results.position
            ) {
              const posTab = defaultTabData.find(
                (pc) => pc.id === oneImage.results.position,
              );
              posTab.images.forEach((oneimg) => {
                if (_.find(otherTab.images, { id: oneimg.id })) {
                  _.remove(
                    otherTab.images,
                    _.find(otherTab.images, { id: oneimg.id }),
                  );
                }
              });
            }
            // hide other tab if no images present
            if (otherTab.images.length === 0) {
              otherTab.isVisible = false;
            }
          }
        });
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.refreshSummaryKey = Math.random();
        const defaultTabResult = defaultTabData.filter(
          (item) => item.id !== 'summary' && item.isVisible,
        );
        const tabResults = [];
        defaultTabResult.forEach((element) => {
          if (element.id !== 'others') {
            const result = this.getTabSeverityDecision(element.id);
            tabResults.push(result);
          } else {
            tabResults.push({
              position: element.id,
              repairCount: -1,
              replaceCount: -1,
            });
          }
        });

        const qa = _.sortBy(
          tabResults,
          (item) => item.replaceCount,
          (item) => item.repairCount,
        ).reverse();

        const sortedTabs = [];
        qa.forEach((element) => {
          const tab = _.filter(defaultTabData, (a) => a.id === element.position);
          const ddt = { ...tab };
          sortedTabs.push(ddt[0]);
        });
        return sortedTabs;
      }
      return null;
    },

    getPartsMapping() {
      const { results } = this.currentClaim;
      if (results && results.vehicle_operations && results.vehicle_operations.length > 0) {
        const mappedParts = this.currentClaim.results.vehicle_operations.map((x) => ({
          [x.part_name]: x.name,
        }));
        let partsMapping = {};
        mappedParts.forEach((element) => {
          partsMapping = _.merge(partsMapping, element);
        });
        return partsMapping;
      }
      return {};
    },

    // #region [Parts Summary]
    priceInfo() {
      const priceData = {
        claimInfo: {
          processing_completed_at: this.currentClaim.processing_completed_at,
          vehicle_code: this.currentClaim.vehicle_code,
        },
        vehicle_operations: this.currentClaim.results.vehicle_operations,
        part_pricing: this.currentClaim.results.part_pricing,
        languageCode: this.languageCode,
        enableEditOem: this.enableEditOem,
        enableInternalPartsEdit: this.enableInternalPartsEdit,
        partName: this.selectedPartName,
        paint_type: this.currentClaim.paint_type,
        city_category: this.currentClaim.city_category,
        priceRefreshKey: Math.random(),
        compulsory_excess: this.currentClaim.compulsory_excess || 0,
      };
      return priceData;
    },
    damageSummary() {
      const price = this.priceInfo;
      if (
        this.currentClaim
        && this.currentClaim.uid
        && this.currentClaim.results.images
        && price
      ) {
        const { claimMeta } = this.currentClaim;
        const obj = [];
        const dt = this.currentClaim.results.vehicle_operations || [];
        this.GetDamagedPartsCount();
        dt.forEach((element) => {
          let isSmartAssociationExist = false;
          let overrideModel = null;
          if (claimMeta && claimMeta.part_level_confidence) {
            if (element.review_flag && element.smart_association && element.decision === (element.smart_association.suggestion === 'do_nothing' ? 'part_damage_not_identified' : element.smart_association.suggestion)) {
              isSmartAssociationExist = true;
              // overrideModel = element.smart_association.model;
              overrideModel = 'smart_association';
            } else if (element.smart_association && element.smart_association.model === 'smart_association' && element.decision === (element.smart_association.suggestion === 'do_nothing' ? 'part_damage_not_identified' : element.smart_association.suggestion)) {
              isSmartAssociationExist = true;
              overrideModel = 'smart_association';
            }
          } else if (element.smart_association && element.decision === (element.smart_association.suggestion === 'do_nothing' ? 'part_damage_not_identified' : element.smart_association.suggestion)) {
            isSmartAssociationExist = true;
            overrideModel = element.smart_association.model;
          }

          if (['wheel_front_left', 'wheel_front_right', 'wheel_rear_left', 'wheel_rear_right', 'rim_front_left', 'rim_front_right', 'rim_rear_left', 'rim_rear_right', 'tyre_front_left', 'tyre_front_right', 'tyre_rear_left', 'tyre_rear_right'].indexOf(element.part_name) > 0 && element.decision === 'replace') {
            if (element.model_override && element.decision === (element.model_override.suggestion === 'do_nothing' ? 'part_damage_not_identified' : element.model_override.suggestion)) {
              isSmartAssociationExist = true;
              overrideModel = 'smart_association';
            }
          }

          const newPart = {
            label: element.part_name,
            name: element.name,
            part_code: element.part_code,
            isDamaged: false,
            isSmartAssociationExist,
            overrideModel,
          };
          if (
            element
            && element.damages
            && Object.keys(element.damages).length > 0
          ) {
            newPart.area = element.damages.part_area;
            newPart.scratch_count = element.damages.scratch;
            newPart.dent_count = element.damages.dent;
            newPart.tear_count = element.damages.tear;
            newPart.decision = element.decision === 'part_damage_not_identified' ? 'None' : element.decision;
            newPart.ch = element.damages.ch;
            newPart.pp = element.damages.pp;
            newPart.scratch_damage_threshold = element.damages.scratch_damage_threshold;
            newPart.dent_damage_threshold = element.damages.dent_damage_threshold;
            newPart.tear_damage_threshold = element.damages.tear_damage_threshold;
            newPart.isDamaged = true;
            const associatedPartsDetails = this.getAssociatedParts(
              // element.part_name,
              element.part_code,
            );
            if (associatedPartsDetails) {
              newPart.price = associatedPartsDetails.cost.total_price;
              newPart.paint_charge = associatedPartsDetails.cost.paint_charge;
              newPart.items = associatedPartsDetails.parts;
            } else {
              newPart.price = 0;
              newPart.items = [];
            }
          } else if (element.decision === 'part_damage_not_identified') {
            newPart.area = element && element.damages ? element.damages.part_area : 0;
            newPart.decision = 'None';
            newPart.isDamaged = false;
            const associatedPartsDetails = this.getAssociatedParts(
              // element.part_name,
              // element.name,
              element.part_code,
            );
            if (associatedPartsDetails) {
              newPart.price = 0;
              newPart.paint_charge = 0;
              newPart.items = associatedPartsDetails.parts;
            } else {
              newPart.price = 0;
              newPart.paint_charge = 0;
              newPart.items = [];
            }
          } else {
            newPart.area = element && element.damages ? element.damages.part_area : 0;
            newPart.scratch_count = 0;
            newPart.dent_count = 0;
            newPart.tear_count = 0;
            newPart.decision = element.decision;
            newPart.isDamaged = false;
            newPart.ch = element.damages.ch;
            newPart.pp = element.damages.pp;
            newPart.scratch_damage_threshold = element.damages.scratch_damage_threshold;
            newPart.dent_damage_threshold = element.damages.dent_damage_threshold;
            newPart.tear_damage_threshold = element.damages.tear_damage_threshold;
            const associatedPartsDetails = this.getAssociatedParts(
              // element.part_name,
              // element.name,
              element.part_code,
            );
            if (associatedPartsDetails) {
              newPart.price = associatedPartsDetails.cost.total_price;
              newPart.paint_charge = associatedPartsDetails.cost.paint_charge;
              newPart.items = associatedPartsDetails.parts;
            } else {
              newPart.price = 0;
              newPart.paint_charge = 0;
              newPart.items = [];
            }
          }
          obj.push(newPart);
        });
        const SortedObj = obj.sort((a, b) => {
          const c = a;
          const d = b;
          if (!a.scratch_count) {
            c.scratch_count = 0;
          }
          if (!b.scratch_count) {
            d.scratch_count = 0;
          }
          if (!a.dent_count) {
            c.dent_count = 0;
          }
          if (!b.dent_count) {
            d.dent_count = 0;
          }
          return (
            a.scratch_count - b.dent_count || a.dent_count - b.scratch_count
          );
        });
        const decisionsArr = [
          'replace',
          'repair',
          'None',
          'part_not_identified',
        ];
        let finalSortedObj = [];
        decisionsArr.forEach((val) => {
          let filteredObj = SortedObj.filter((a) => a.decision === val);
          filteredObj = _.orderBy(filteredObj, ['scratch_count', 'dent_count', 'tear_count'], ['desc', 'desc', 'desc']);
          finalSortedObj = [...finalSortedObj, ...filteredObj];
        });
        return finalSortedObj;
      }
      return null;
    },
    internalPartList() {
      const price = this.priceInfo;
      let intParts = [];
      if (this.isClaimProcessingCompleted && this.currentClaim.results && this.currentClaim.results.part_pricing && this.currentClaim.results.part_pricing.parts && price) {
        const filteredParts = _.filter(this.currentClaim.results.part_pricing.parts, (a) => a.decision === 'replace');
        filteredParts.forEach((item) => {
          intParts = _.concat(intParts, _.filter(item.internal_parts, (a) => a.is_selected === true));
        });
      }
      intParts.forEach((item) => {
        const part = item;
        part.meta.total_repair_cost = this.convertTwoDecimal(this.convertTwoDecimal(part.meta.total_part_with_gst || 0) + this.convertTwoDecimal(part.meta.total_labour_with_gst || 0) + this.convertTwoDecimal(part.meta.total_paint_with_gst || 0));
      });
      return intParts;
    },
    // #endregion

    // #region [Action Bar]
    claimImages() {
      // eslint-disable-next-line camelcase
      const { results, processing_started_at } = this.currentClaim;
      if (this.isClaimProcessingCompleted && results && results.images && results.images.length > 0) {
        return results.images.map((x) => ({
          id: x.id,
          url: x.url,
          image_key: x.key || null,
          isNewlyAdded: false,
          uploadedAt: processing_started_at,
        }));
      }
      return [];
    },

    claimVideos() {
      // eslint-disable-next-line camelcase
      const { results, processing_started_at } = this.currentClaim;
      if (this.isClaimProcessingCompleted && results && results.videos && results.videos.length > 0) {
        return results.videos.map((x) => ({
          id: x.id,
          url: x.url,
          image_key: x.key || null,
          isNewlyAdded: false,
          uploadedAt: processing_started_at,
        }));
      }
      return [];
    },

    enableReprocessing() {
      if (this.isClaimProcessingCompleted) {
        const { claimMeta } = this.currentClaim;
        if (claimMeta) {
          return claimMeta.enable_reprocessing || false;
        }
        return true;
      }
      return true;
    },

    claimVersions() {
      const { claimMeta } = this.currentClaim;
      if (claimMeta && claimMeta.versions && claimMeta.versions.length > 0) {
        const claimVersions = {
          versions: claimMeta.versions,
          selectedClaimId: this.fetchedClaimId || this.currentClaim.id, // Need to modify later
          showClaimVersions: !claimMeta.is_final_version,
        };
        const maxVersion = _.maxBy(claimMeta.versions, 'id');
        if (claimMeta.enable_reprocessing ? claimMeta.enable_reprocessing : false) { // Need to modify later
          claimVersions.versions.unshift({
            id: null,
            version: Number(maxVersion.version) + 1,
            processingDate: 'Pending Reprocess',
            modelVersion: this.currentClaim.currentModelVersion,
          });
        }
        return claimVersions;
      }
      return {};
    },

    showResubmitButton() {
      const { claimMeta, id } = this.currentClaim;
      let enableResubmitButton = true;
      if (this.isClaimProcessingCompleted && claimMeta && claimMeta.versions && claimMeta.versions.length > 0) {
        const maxVersion = _.maxBy(claimMeta.versions, 'id');
        if (maxVersion && maxVersion.id) {
          if (Number(id) === Number(maxVersion.id)) {
            enableResubmitButton = true;
          } else {
            enableResubmitButton = false;
          }
        }
      }
      if (claimMeta.is_final_version) { enableResubmitButton = false; }
      return enableResubmitButton;
    },
    pdfData() {
      const data = {
        vehicleInfo: {
          uid: this.currentClaim.uid,
          claim_number: this.currentClaim.claim_number,
          make: this.currentClaim.make,
          model: this.currentClaim.model,
          mileage: this.currentClaim.mileage,
          year: this.currentClaim.year,
          state: this.currentClaim.state,
          country: this.currentClaim.country,
          vin: this.currentClaim.vin,
          loss_year: this.currentClaim.loss_year,
          registration_number: this.currentClaim.registration_number,
          registration_date: this.currentClaim.registration_date,
          compulsory_excess: this.currentClaim.compulsory_excess,
          repairability_status: this.currentClaim.results.repairability_status,
          repair_est: this.getTotalGrossRepairEstimate,
        },
        images: [],
        showNote: this.showNote,
        currency: this.$cgiSettings.currency,
        grossRepairEstimate: {
          totalPartPrice: 0,
          totalLabourCost: 0,
          totalRepairCost: 0,
          totalPaintCost: 0,
          totalInternalPartPrice: 0,
          totalInternalLabourCost: 0,
          totalInternalPaintCost: 0,
          totalDepreciationAmount: 0,
          grossRepairAmount: 0,
          RepairCost: 0,
          compulsoryExcess: 0,
        },
        partSummary: this.damageSummary,
        internalPartList: this.internalPartList,
        depreciationSummary: (this.currentClaim && this.currentClaim.part_pricing && this.currentClaim.part_pricing.summary) ? this.currentClaim.part_pricing.summary : null,
        showSummaryOnly: this.showEstimationSummaryOnly,
        isPDAS: true,
        emailImageUrl: '',
      };

      data.images = this.currentClaim.results.images.map((a) => ({
        id: a.id,
        url: a.results.damage_masked_image || a.url,
      }));
      let imageUrl = '';
      this.currentClaim.results.images.every((oneImage) => {
        if ((oneImage.results.is_car === 'car' || oneImage.results.is_car === 'partial_car') && imageUrl === '') {
          imageUrl = oneImage.results.damage_masked_image || oneImage.url;
        }
        if (imageUrl !== '') {
          return false;
        }
        return true;
      });
      if (imageUrl === '' && data && data.images && data.images.length > 0) {
        imageUrl = data.images[0].url;
      }
      data.emailImageUrl = imageUrl;
      let templateId = window.localStorage.getItem('region') != null
        && window.localStorage.getItem('region') === 'IN'
        ? 'IN'
        : 'default';
      templateId = templateId === 'default' && this.clientId === '54' ? 'UNITPDAS' : this.estimateTemplateId;
      data.logoUrl = this.clientLogo;
      data.isLandscape = this.isLandscape;
      data.emailSettings = this.$cgiSettings.detailsForm.emailSettings;
      return {
        data,
        templateId,
      };
    },
    // #endregion

    getPositionWiseParts() {
      const bodyType = this.getBodyType();
      return this.bodyTypeBasedParts[bodyType];
    },
  },
  watch: {
    selectedTab: 'getTabStatus',
  },
  created() {
    this.refresh();
  },
  mounted() {
    this.getClaimDetails();
    this.setAnnotateMode();
  },
  methods: {
    convertTwoDecimal(data) {
      return parseFloat(parseFloat(data || 0).toFixed(2));
    },
    refresh() {
      defaultTabData.forEach((tab) => {
        // eslint-disable-next-line no-param-reassign
        tab.images = [];
        // eslint-disable-next-line no-param-reassign
        tab.isVisible = false;
      });
    },

    async getClaimDetails() {
      if (this.$route.params.claimUID) {
        let url = `/202103/claims/${this.$route.params.claimUID}?claimMeta=true&transformResponse=true&damageDetails=true&gstTransformResponse=true`;
        // if (this.claimVersions && this.claimVersions.selectedClaimId && this.claimVersions.selectedClaimId !== null) {
        if (this.claimVersions && this.fetchedClaimId && this.fetchedClaimId !== null) {
          url = `/202103/claims/${this.$route.params.claimUID}?claimMeta=true&transformResponse=true&claimId=${this.fetchedClaimId}&gstTransformResponse=true`;
        }
        this.currentClaim = await this.$http.get(
          url,
        );
        this.claimInfo = {
          id: this.currentClaim.id,
          uid: this.currentClaim.uid,
          claimDate: this.currentClaim.processing_started_at,
          make: this.currentClaim.make,
          model: this.currentClaim.model,
          year: this.currentClaim.year,
          mileage: this.currentClaim.mileage,
          state: this.currentClaim.state,
          airbagDeployed: this.currentClaim.results.airbag_deployed || false,
          confidenceMeter: this.getConfidenceScore(),
          damageMeter: this.getDamageMeterValue,
          totalGrossRepairEstimate: this.getTotalGrossRepairEstimate,
          isClaimProcessingComplete: this.isClaimProcessingCompleted,
          repairabilityStatus: this.repairabilityStatus,
          compulsory_excess: this.currentClaim.compulsory_excess,
        };

        // this.priceInfo = {
        //   claimInfo: {
        //     processing_completed_at: this.currentClaim.processing_completed_at,
        //     vehicle_code: this.currentClaim.vehicle_code,
        //   },
        //   vehicle_operations: this.currentClaim.results.vehicle_operations,
        //   part_pricing: this.currentClaim.results.part_pricing,
        //   languageCode: this.languageCode,
        //   enableEditOem: this.enableEditOem,
        //   enableInternalPartsEdit: this.enableInternalPartsEdit,
        //   partName: this.selectedPartName,
        // };

        if (!this.currentClaim.processing_completed_at) {
          this.showLink = true;
          if (this.currentClaim.processing_percentage && this.currentClaim.processing_percentage !== null) {
            const processPercent = this.currentClaim.processing_percentage.slice(0, -1);
            if (Number(processPercent) >= 100) {
              this.processPercent = 97;
            } else {
              this.processPercent = Number(processPercent);
            }
            this.progressRefreshKey = Math.random();
          }
          setTimeout(() => {
            this.getClaimDetails();
          }, 5000);
        } else {
          // this.claimInfoRefreshKey = Math.random();
          // this.actionBarRefreshKey = Math.random();

          this.claimInfoRefreshKey = Math.random();
          this.illustrationRefreshKey = Math.random();
          this.damageViewerRefreshKey = Math.random();
          this.actionBarRefreshKey = Math.random();
          this.refreshSummaryKey = Math.random();
          this.estimationReportRefreshKey = Math.random();
          this.tabRefreshKey = Math.random();
          this.isProcessing = false;
          this.showLink = false;
        }
      }
    },

    getConfidenceScore() {
      if (this.isClaimProcessingCompleted && this.currentClaim.results) {
        // eslint-disable-next-line camelcase
        const { claimMeta } = this.currentClaim;
        // eslint-disable-next-line camelcase
        if (claimMeta && claimMeta.confidence_score && claimMeta.confidence_score !== 'NA') {
          // eslint-disable-next-line camelcase
          const confidenceMeter = claimMeta.confidence_score * 100;
          if (confidenceMeter === 0) {
            return 0;
          } if (confidenceMeter <= 10) {
            return 12;
          } if (confidenceMeter <= 20) {
            return 17;
          } if (confidenceMeter <= 30) {
            return 22;
          } if (confidenceMeter <= 43) {
            return 30;
          } if (confidenceMeter <= 46) {
            return 35;
          } if (confidenceMeter <= 50) {
            return 40;
          } if (confidenceMeter <= 52) {
            return 55;
          } if (confidenceMeter <= 56) {
            return 65;
          } if (confidenceMeter <= 60) {
            return 80;
          } if (confidenceMeter <= 63) {
            return 95;
          } if (confidenceMeter <= 90) {
            return 97;
          } if (confidenceMeter <= 100) {
            return 99;
          }
          return 0;
        }
        return 1;
      }
      return 1;
    },

    getTabStatus() {
      if (this.selectedTab === 0) {
        this.imageIndex = 0;
        this.showIllustration = true;
      }
    },

    onPositionTabChanged() {
      this.showIllustration = false;
    },

    getPartDamages(imageResults) {
      const parts = [];
      if (imageResults && imageResults.parts) {
        imageResults.parts.forEach((onePart) => {
          parts.push({ label: onePart, isDamaged: false });
        });

        if (imageResults.part_damages && imageResults.part_damages.length > 0) {
          const damagedParts = _.filter(
            this.currentClaim.results.vehicle_operations,
            (a) => a.decision !== 'part_not_identified',
          );
          imageResults.part_damages.forEach((oneDamage) => {
            const fetchedPart = parts.find(
              (pc) => pc.label === oneDamage.part_name,
            );
            if (fetchedPart) {
              const partExist = damagedParts.find((x) => x.part_name === oneDamage.part_name);
              fetchedPart.score = (oneDamage.part_polygon && oneDamage.part_polygon.score) ? oneDamage.part_polygon.score : 0;
              fetchedPart.area = oneDamage.part_area || 0;
              fetchedPart.scratch_count = (partExist && partExist.damages && partExist.damages.scratch) ? partExist.damages.scratch : 0;
              fetchedPart.dent_count = (partExist && partExist.damages && partExist.damages.dent) ? partExist.damages.dent : 0;
              fetchedPart.tear_count = (partExist && partExist.damages && partExist.damages.tear) ? partExist.damages.tear : 0;
              fetchedPart.damages = oneDamage.damages || [];
              fetchedPart.decision = (partExist && partExist.decision) ? partExist.decision : 'None';
              fetchedPart.price = ((partExist && partExist.labour_price) ? partExist.labour_price : 0) + ((partExist && partExist.part_price) ? partExist.part_price : 0);

              if (oneDamage.damages && oneDamage.damages.length > 0) {
                fetchedPart.isDamaged = true;
              }
            } else {
              const partExist = damagedParts.find((x) => x.part_name === oneDamage.part_name);
              const newPart = { label: oneDamage.part_name, isDamaged: false };
              newPart.score = (oneDamage.part_polygon && oneDamage.part_polygon.score) ? oneDamage.part_polygon.score : 0;
              newPart.area = oneDamage.part_area || 0;
              newPart.scratch_count = oneDamage.scratch_count || 0;
              newPart.dent_count = oneDamage.dent_count || 0;
              newPart.tear_count = oneDamage.tear_count || 0;
              newPart.damages = oneDamage.damages || [];
              fetchedPart.decision = (partExist && partExist.decision) ? partExist.decision : 'None';
              fetchedPart.price = ((partExist && partExist.labour_price) ? partExist.labour_price : 0) + ((partExist && partExist.part_price) ? partExist.part_price : 0);
              if (oneDamage.damages && oneDamage.damages.length > 0) {
                newPart.isDamaged = true;
              }
              parts.push(newPart);
            }
          });
        }
      }
      const SortedParts = parts.sort((a, b) => {
        const c = a;
        const d = b;
        if (!a.scratch_count) {
          c.scratch_count = 0;
        }
        if (!b.scratch_count) {
          d.scratch_count = 0;
        }
        if (!a.dent_count) {
          c.dent_count = 0;
        }
        if (!b.dent_count) {
          d.dent_count = 0;
        }
        return a.scratch_count - b.dent_count || a.dent_count - b.scratch_count;
      });
      return SortedParts.reverse();
      // return parts;
    },

    getImageFeatures(results) {
      const allFeatures = [
        { name: 'parts', features: [] },
        { name: 'dent', features: [] },
        { name: 'scratch', features: [] },
        { name: 'tear', features: [] },
      ];
      if (results && results.length > 0) {
        let scrCnt = 0;
        let dntCnt = 0;
        let tearCnt = 0;
        results.forEach((element) => {
          if (element.part_polygon && !_.isEmpty(element.part_polygon)) {
            allFeatures
              .find((a) => a.name === 'parts')
              .features.push({
                type: 'parts',
                name: `parts-${element.part_polygon.label}`,
                coordinates: [element.part_polygon.points],
                meta: {
                  label: element.part_polygon.label,
                },
              });
          }
          if (element.damages && element.damages.length > 0) {
            element.damages.forEach((onedamage) => {
              if (onedamage.type === 'scratch') {
                allFeatures
                  .find((a) => a.name === 'scratch')
                  .features.push({
                    type: 'scratch',
                    name: `scratch_${scrCnt}`,
                    coordinates: [onedamage.polygon],
                    meta: {
                      label: element.part_name,
                    },
                  });
                scrCnt += 1;
              }
              if (onedamage.type === 'dent') {
                allFeatures
                  .find((a) => a.name === 'dent')
                  .features.push({
                    type: 'dent',
                    name: `dent_${dntCnt}`,
                    coordinates: [onedamage.polygon],
                    meta: {
                      label: element.part_name,
                    },
                  });
                dntCnt += 1;
              }

              if (onedamage.type === 'ch' || onedamage.type === 'tear') {
                allFeatures
                  .find((a) => a.name === 'tear')
                  .features.push({
                    type: 'tear',
                    name: `tear-${tearCnt}`,
                    coordinates: [onedamage.polygon],
                    meta: {
                      label: element.part_name,
                    },
                  });
                tearCnt += 1;
              }
            });
          }
        });
      }
      return allFeatures;
    },

    getNonCarImageFeatures(results) {
      const allFeatures = [
        { name: 'parts', features: [] },
        { name: 'dent', features: [] },
        { name: 'scratch', features: [] },
        { name: 'tear', features: [] },
      ];
      if (results) {
        if (results.scratches) {
          results.scratches.forEach((element, index) => {
            allFeatures
              .find((a) => a.name === 'scratch')
              .features.push({
                type: 'scratch',
                name: `scratch_${index + 1}`,
                coordinates: [element.points],
                meta: {
                  label: element.label,
                  severity:
                    element.meta && element.meta.severity
                      ? element.meta.severity
                      : 0,
                },
              });
          });
        }

        if (results.dents) {
          results.dents.forEach((element, index) => {
            allFeatures
              .find((a) => a.name === 'dent')
              .features.push({
                type: 'dent',
                name: `dent_${index + 1}`,
                coordinates: [element.points],
                meta: {
                  label: element.label,
                  severity:
                    element.meta && element.meta.severity
                      ? element.meta.severity
                      : 0,
                },
              });
          });
        }

        if (results.tears) {
          results.tears.forEach((element, index) => {
            allFeatures
              .find((a) => a.name === 'tear')
              .features.push({
                type: 'tear',
                name: `tear_${index + 1}`,
                coordinates: [element.points],
                meta: {
                  label: 'tear',
                  severity:
                    element.meta && element.meta.severity
                      ? element.meta.severity
                      : 0,
                },
              });
          });
        }
        return allFeatures;
      }
      return allFeatures;
    },

    getSeverityValue(position) {
      if (position) {
        let repairCount = 0;
        let replaceCount = 0;
        if (this.currentClaim && this.currentClaim.results.images) {
          this.currentClaim.results.images.forEach((oneImage) => {
            if (oneImage && oneImage.results && oneImage.results.position) {
              if (oneImage.results.position === position) {
                if (oneImage.results.parts && this.currentClaim.results.vehicle_operations) {
                  oneImage.results.parts.forEach((part) => {
                    const damagePart = this.currentClaim.results.vehicle_operations.find(
                      (a) => a.part_name === part,
                    );
                    if (damagePart) {
                      if (damagePart.decision === 'replace') {
                        replaceCount += 1;
                      }
                      if (damagePart.decision === 'repair') {
                        repairCount += 1;
                      }
                    }
                  });
                }
              }
            }
          });
        }

        if (replaceCount > 0) {
          return 'is-danger';
        }
        if (repairCount > 0) {
          return 'is-orange';
        }
        return 'is-success';
      }
      return 'is-success';
    },

    getTabSeverityDecision(position) {
      if (position) {
        let repairCount = 0;
        let replaceCount = 0;
        if (this.currentClaim && this.currentClaim.results.images) {
          // eslint-disable-next-line camelcase
          const { vehicle_operations } = this.currentClaim.results;
          this.currentClaim.results.images.forEach((oneImage) => {
            if (oneImage && oneImage.results && oneImage.results.position) {
              if (oneImage.results.position === position) {
                // eslint-disable-next-line camelcase
                if (oneImage.results.parts && vehicle_operations) {
                  oneImage.results.parts.forEach((part) => {
                    const damagePart = vehicle_operations.find(
                      (a) => a.part_name === part,
                    );
                    if (damagePart) {
                      if (damagePart.decision === 'replace') {
                        replaceCount += 1;
                      }
                      if (damagePart.decision === 'repair') {
                        repairCount += 1;
                      }
                    }
                  });
                }
              }
            }
          });
        }
        return {
          position,
          repairCount,
          replaceCount,
        };
      }
      return null;
    },
    async calculateRepairability() {
      // call getrepairability function to get the last updated status
      const repairabilityStatus = await this.getRepairabilityStatus();
      this.currentClaim.repairability = repairabilityStatus;
      // console.log('repairabilityStatus', repairabilityStatus);
      return this.currentClaim.repairability ? this.currentClaim.repairability : null;
    },

    setAnnotateMode() {
      if (this.$cgiSettings && !this.$cgiSettings.showParts) {
        this.annotateMode = false;
      } else {
        this.annotateMode = true;
      }
    },

    // #region [Parts Summary]
    async selected(dt) {
      this.gotoAirbag = false;
      if (dt.decision === 'part_not_identified') {
        return;
      }

      if (dt.label === 'airbag') {
        const airbagInNonCar = this.currentClaim.results.images.find((x) => x.results.is_car === 'non_car' && x.results.subcategory === 'airbag');
        const airbagInCPC = this.currentClaim.results.images.find((x) => x.results.is_car !== 'non_car' && x.results.subcategory === 'airbag');
        if (airbagInNonCar) {
          this.selectedTab = this.tabData.length;
          this.gotoAirbag = true;
          this.imageIndexKey = Math.random();
        } else if (airbagInCPC) {
          const imagesInTab = this.tabData.find((x) => x.id === airbagInCPC.results.position);
          const index = _.findIndex(
            this.tabData,
            (o) => o.id === airbagInCPC.results.position,
          );
          this.selectedTab = index + 1;
          this.imageIndex = _.findIndex(
            imagesInTab.images,
            (o) => o.id === airbagInCPC.id,
          );
          this.imageIndexKey = Math.random();
        }
      } else {
        const partData = [];
        _.filter(this.currentClaim.results.images, (oneResult) => {
          if (
            oneResult.results.is_car === 'car'
            && oneResult.results.part_damages
          ) {
            _.filter(oneResult.results.part_damages, (oneDamage) => {
              if (oneDamage.part_name === dt.label) {
                const damageData = oneDamage;
                damageData.id = oneResult.id;
                damageData.url = oneResult.url;
                damageData.position = oneResult.results.position;
                // damageData.features = this.getImageFeatures(oneResult.polygons);
                partData.push(oneDamage);
              }
            });
          }
        });
        // console.log('partData=>', JSON.stringify(partData));
        // const newTabData = this.tabData;
        // newTabData.forEach((oneImage) => {
        //   if (this.allPositions.includes(oneImage.id)) {
        //     // newTabData.push(oneImage);
        //   } else {
        //     newTabData.pop();
        //   }
        // });
        // const obj = {
        //   part_name: dt.label,
        //   id: dt.label,
        //   label: dt.label,
        //   images: partData,
        //   isVisible: true,
        // };
        // newTabData.push(obj);
        if (partData.length === 0) {
          _.filter(this.currentClaim.results.images, (oneResult) => {
            if (
              oneResult.results.is_car === 'partial_car'
              && oneResult.results.part_damages
            ) {
              _.filter(oneResult.results.part_damages, (oneDamage) => {
                if (oneDamage.part_name === dt.label) {
                  const damageData = oneDamage;
                  damageData.id = oneResult.id;
                  damageData.url = oneResult.url;
                  damageData.position = oneResult.results.position;
                  partData.push(oneDamage);
                }
              });
            }
          });
        }
        const res = _.orderBy(partData, 'part_area');
        this.selectedTab = 0;
        this.imageIndex = 0;
        this.imageIndexKey = Math.random();
        if (res.length > 0) {
          const partPresent = _.find(
            this.tabData,
            (o) => o.id === res[res.length - 1].position,
          );
          const index = _.findIndex(
            this.tabData,
            (o) => o.id === res[res.length - 1].position,
          );
          this.selectedTab = index + 1;
          this.imageIndex = _.findIndex(
            partPresent.images,
            (o) => o.id === res[res.length - 1].id,
          );
          this.imageIndexKey = Math.random();
        } else {
          this.selectedTab = 0;
          const message = {
            title: this.$t('confirmation_message.part_not_found_title'),
            message: this.$t('confirmation_message.part_not_found_message'),
            confirmText: 'Ok',
            type: 'is-warning',
            iconPack: 'fas',
            hasIcon: true,
          };
          this.$buefy.dialog.alert(message);
          this.showTooltip = null;
        }
      }
    },
    GetDamagedPartsCount() {
      const filteredParts = _.filter(
        this.currentClaim.results.vehicle_operations,
        (a) => a.decision !== 'part_not_identified',
      );
      const damagedParts = _.filter(
        filteredParts,
        (a) => a.decision !== 'part_damage_not_identified',
      );
      this.damagePartsCount = damagedParts.length;
      // this.aiAnalysisDetails.damagePartsCount = damagedParts.length;
    },

    getAssociatedParts(partCode) {
      const associatedPartsWithPrice = this.currentClaim.results.part_pricing || {};
      if (partCode) {
        const totalCost = {
          part_price: 0,
          labour_time: 0,
          labour_price: 0,
          paint_charge: 0,
          internal_part_price: 0,
          internal_labour_price: 0,
          internal_paint_charge: 0,
          meta: {
            total_part_with_gst: 0,
            total_labour_with_gst: 0,
            total_paint_with_gst: 0,
            aux_parts_total_part_with_gst: 0,
            aux_parts_total_labour_with_gst: 0,
            aux_parts_total_paint_with_gst: 0,
            int_parts_total_part_with_gst: 0,
            int_parts_total_labour_with_gst: 0,
            int_parts_total_paint_with_gst: 0,
          },
          total_price: 0,
        };
        const allAssociatedParts = _.find(
          associatedPartsWithPrice.parts,
          (pc) => {
            if (pc.part_code === partCode && pc.meta) {
              totalCost.part_price = this.convertTwoDecimal(pc.total_part_price || 0);
              totalCost.labour_time = this.convertTwoDecimal(pc.total_labour_hours || 0);
              totalCost.labour_price = this.convertTwoDecimal(pc.total_labour_price || 0);
              totalCost.paint_charge = this.convertTwoDecimal(pc.total_paint_price || 0);
              totalCost.internal_part_price = this.convertTwoDecimal(pc.total_internal_part_price || 0);
              totalCost.internal_paint_charge = this.convertTwoDecimal(pc.total_internal_paint_price || 0);
              totalCost.internal_labour_price = this.convertTwoDecimal(pc.total_internal_labour_price || 0);
              totalCost.meta.total_part_with_gst = this.convertTwoDecimal(pc.meta.total_part_with_gst || 0);
              totalCost.meta.total_labour_with_gst = this.convertTwoDecimal(pc.meta.total_labour_with_gst || 0);
              totalCost.meta.total_paint_with_gst = this.convertTwoDecimal(pc.meta.total_paint_with_gst || 0);
              totalCost.meta.aux_parts_total_part_with_gst = this.convertTwoDecimal(pc.meta.aux_parts_total_part_with_gst || 0);
              totalCost.meta.aux_parts_total_labour_with_gst = this.convertTwoDecimal(pc.meta.aux_parts_total_labour_with_gst || 0);
              totalCost.meta.aux_parts_total_paint_with_gst = this.convertTwoDecimal(pc.meta.aux_parts_total_paint_with_gst || 0);
              totalCost.meta.int_parts_total_part_with_gst = this.convertTwoDecimal(pc.meta.int_parts_total_part_with_gst || 0);
              totalCost.meta.int_parts_total_labour_with_gst = this.convertTwoDecimal(pc.meta.int_parts_total_labour_with_gst || 0);
              totalCost.meta.int_parts_total_paint_with_gst = this.convertTwoDecimal(pc.meta.int_parts_total_paint_with_gst || 0);

              totalCost.total_price = parseFloat(
                this.convertTwoDecimal(totalCost.meta.total_part_with_gst) + this.convertTwoDecimal(totalCost.meta.total_labour_with_gst) + this.convertTwoDecimal(totalCost.meta.total_paint_with_gst)
                  + this.convertTwoDecimal(totalCost.meta.aux_parts_total_part_with_gst) + this.convertTwoDecimal(totalCost.meta.aux_parts_total_labour_with_gst) + this.convertTwoDecimal(totalCost.meta.aux_parts_total_paint_with_gst),
                // + totalCost.meta.int_parts_total_part_with_gst + totalCost.meta.int_parts_total_labour_with_gst + totalCost.meta.int_parts_total_paint_with_gst,
              ).toFixed(2);
              return pc;
            }
            return null;
          },
        );
        let mainPartObj = null;
        if (allAssociatedParts) {
          mainPartObj = JSON.parse(JSON.stringify(allAssociatedParts));
          delete mainPartObj.auxiliary_parts;
          delete mainPartObj.decision;
        }
        return {
          cost: totalCost,
          // parts: allAssociatedParts ? _.concat(allAssociatedParts.auxiliary_parts, mainPartObj) : [],
          parts: allAssociatedParts || [],
        };
      }
      return null;
    },
    async updateMainPartDecision(partDetails, reRunTheClaim = false) {
      this.showTooltip = null;
      this.loaderText = 'Updating Part Decision';
      this.isProcessing = true;
      if (this.currentClaim.results.vehicle_operations && this.currentClaim.results.vehicle_operations.length > 0) {
        const repairReplacePartsExists = this.currentClaim.results.vehicle_operations.filter(
          (a) => a.decision === 'replace' || a.decision === 'repair',
        );
        if (repairReplacePartsExists.length === 1 && (partDetails.decision !== 'replace' || partDetails.decision !== 'repair')) {
          // eslint-disable-next-line no-param-reassign
          reRunTheClaim = true;
        }
        if (repairReplacePartsExists.length === 0 && (partDetails.decision === 'replace' || partDetails.decision === 'repair')) {
          // eslint-disable-next-line no-param-reassign
          reRunTheClaim = true;
        }
        const selectedPart = this.currentClaim.results.vehicle_operations.find(
          (a) => a.part_code === partDetails.part_code,
        );
        if (selectedPart && selectedPart.part_name === 'airbag') {
          // eslint-disable-next-line no-param-reassign
          reRunTheClaim = true;
        }
      }
      if (partDetails.decision.toLowerCase() === 'none' || partDetails.decision === 'part_damage_not_identified' || partDetails.decision === 'part_not_identified') {
        const selectedPartData = JSON.parse(
          JSON.stringify(defaultPartObject),
        );
        selectedPartData.part_code = partDetails.part_code;
        selectedPartData.part_name = partDetails.part_name;
        selectedPartData.part_std_name = partDetails.part_std_name;
        selectedPartData.decision = partDetails.decision.toLowerCase() === 'none' ? 'part_damage_not_identified' : partDetails.decision;
        selectedPartData.is_selected = true;
        await this.partPricingUpdated(selectedPartData);
        this.claimInfoRefreshKey = Math.random();
      } else {
        const vehicleOperation = _.filter(this.currentClaim.results.vehicle_operations, ['part_code', partDetails.part_code]);
        let internalParts = [];
        if (vehicleOperation.length > 0 && partDetails.decision.toLowerCase() === 'replace') {
          internalParts = _.map(vehicleOperation[0].smart_association_internal, (a) => _.pick(a, ['part_code', 'decision']));
        }
        const pricingFilters = {};
        if (this.currentClaim.paint_type) {
          pricingFilters.paint_type = this.currentClaim.paint_type;
        }
        if (this.currentClaim.city_category) {
          pricingFilters.city_category = this.currentClaim.city_category;
        }
        const damageDetails = _.find(this.damageSummary, ['part_code', partDetails.part_code]);
        const defaultDamageObj = {
          dent: damageDetails.dent_count || 0,
          scratch: damageDetails.scratch_count || 0,
          tear: damageDetails.tear_count || 0,
          pp: damageDetails.pp || 0,
          ch: damageDetails.ch || 0,
          part_area: damageDetails.area || 0,
          dent_damage_threshold: damageDetails.dent_damage_threshold || 0,
          scratch_damage_threshold: damageDetails.scratch_damage_threshold || 0,
          tear_damage_threshold: damageDetails.tear_damage_threshold || 0,
        };
        const partObj = {
          claim_id: this.currentClaim.id,
          vehicle_code: this.currentClaim.vehicle_code,
          include_aux_parts: true,
          exclude_aux_parts_price: this.excludeAuxilaryPartPrice,
          language_code: this.languageCode,
          parts: [
            {
              part_code: partDetails.part_code, // 'CG10010005',
              decision: partDetails.decision,
              damages: defaultDamageObj,
              internal_parts: internalParts,
            },
          ],
          filters: pricingFilters,
        };
        const pricingOutput = await this.$http.post(
          '202103/pricing/part-price',
          partObj,
        );
        if (pricingOutput && pricingOutput.parts && pricingOutput.parts.length > 0) {
          const associatedPartsData = pricingOutput.parts[0];
          const onePart = associatedPartsData;
          // onePart.quantity = 1;
          // onePart.dent_hours = 0;
          onePart.gst = this.partGstPercent;
          onePart.labour_price = this.convertTwoDecimal(((onePart.labour_rate || 0) * (onePart.labour_hours || 0)) + ((onePart.labour_rate || 0) * (onePart.dent_hours || 0)));
          onePart.paint_price = this.convertTwoDecimal(((onePart.paint_rate || 0)) + (onePart.material_cost || 0));
          onePart.part_price = this.convertTwoDecimal((((onePart.part_price || 0) * 100) / (100 + (parseFloat(this.partGstPercent)))));

          onePart.auxiliary_parts.forEach((auxElement) => {
            const auxPart = auxElement;
            // auxPart.quantity = 1;
            // auxPart.dent_hours = 0;
            auxPart.gst = this.partGstPercent;
            auxPart.labour_price = this.convertTwoDecimal(((auxPart.labour_rate || 0) * (auxPart.labour_hours || 0)) + ((auxPart.labour_rate || 0) * (auxPart.dent_hours || 0)));
            auxPart.paint_price = this.convertTwoDecimal(((auxPart.paint_rate || 0)) + (auxPart.material_cost || 0));
            auxPart.part_price = this.convertTwoDecimal((((auxPart.part_price || 0) * 100) / (100 + (parseFloat(this.partGstPercent)))));
            auxPart.meta = {
              labour_gst: this.labourTaxPercent,
              paint_gst: this.paintTaxPercent,
              total_labour_with_gst: this.convertTwoDecimal(((auxPart.labour_price || 0) + ((auxPart.labour_price || 0) * (this.labourTaxPercent / 100)))),
              total_paint_with_gst: this.convertTwoDecimal(((auxPart.paint_price || 0) + ((auxPart.paint_price || 0) * (this.paintTaxPercent / 100)))),
              total_part_with_gst: this.convertTwoDecimal((((auxPart.part_price || 0) * (auxPart.quantity || 0)) + (((auxPart.part_price || 0) * (auxPart.quantity || 0)) * (this.partGstPercent / 100)))),
            };
          });
          onePart.internal_parts.forEach((intElement) => {
            const intPart = intElement;
            // intPart.quantity = 1;
            // intPart.dent_hours = 0;
            intPart.gst = this.partGstPercent;
            intPart.labour_price = this.convertTwoDecimal(((intPart.labour_rate || 0) * (intPart.labour_hours || 0)) + ((intPart.labour_rate || 0) * (intPart.dent_hours || 0)));
            intPart.paint_price = this.convertTwoDecimal(((intPart.paint_rate || 0)) + (intPart.material_cost || 0));
            intPart.part_price = this.convertTwoDecimal((((intPart.part_price || 0) * 100) / (100 + (parseFloat(this.partGstPercent)))));
            intPart.meta = {
              labour_gst: this.labourTaxPercent,
              paint_gst: this.paintTaxPercent,
              total_labour_with_gst: this.convertTwoDecimal(((intPart.labour_price || 0) + ((intPart.labour_price || 0) * (this.labourTaxPercent / 100)))),
              total_paint_with_gst: this.convertTwoDecimal(((intPart.paint_price || 0) + ((intPart.paint_price || 0) * (this.paintTaxPercent / 100)))),
              total_part_with_gst: this.convertTwoDecimal((((intPart.part_price || 0) * (intPart.quantity || 0)) + (((intPart.part_price || 0) * (intPart.quantity || 0)) * (this.partGstPercent / 100)))),
            };
          });
          onePart.total_part_price = this.convertTwoDecimal(Number((onePart.part_price || 0)) + _.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.part_price || 0))));
          onePart.total_labour_price = this.convertTwoDecimal(Number((onePart.labour_price || 0)) + _.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.labour_price || 0))));
          onePart.total_paint_price = this.convertTwoDecimal(Number((onePart.paint_price || 0)) + _.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number(a.paint_price || 0)));
          onePart.meta = {
            labour_gst: this.labourTaxPercent,
            paint_gst: this.paintTaxPercent,
            total_labour_with_gst: this.convertTwoDecimal(((onePart.labour_price || 0) + ((onePart.labour_price || 0) * (this.labourTaxPercent / 100)))),
            total_paint_with_gst: this.convertTwoDecimal(((onePart.paint_price || 0) + ((onePart.paint_price || 0) * (this.paintTaxPercent / 100)))),
            total_part_with_gst: this.convertTwoDecimal((((onePart.part_price || 0) * (onePart.quantity || 0)) + (((onePart.part_price || 0) * (onePart.quantity || 0)) * (this.partGstPercent / 100)))),
            aux_parts_total_labour_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.meta.total_labour_with_gst || 0)))),
            aux_parts_total_paint_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.meta.total_paint_with_gst || 0)))),
            aux_parts_total_part_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.meta.total_part_with_gst || 0)))),
            int_parts_total_labour_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.internal_parts, ['is_selected', true]), (a) => Number((a.meta.total_labour_with_gst || 0)))),
            int_parts_total_paint_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.internal_parts, ['is_selected', true]), (a) => Number((a.meta.total_paint_with_gst || 0)))),
            int_parts_total_part_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.internal_parts, ['is_selected', true]), (a) => Number((a.meta.total_part_with_gst || 0)))),
          };
          onePart.is_selected = true;
          await this.partPricingUpdated(onePart, reRunTheClaim);
          this.claimInfoRefreshKey = Math.random();
        }
      }
      this.claimInfoRefreshKey = Math.random();
    },
    async partPricingUpdated(partObj, reRunTheClaim = false) {
      if (partObj) {
        // eslint-disable-next-line no-param-reassign
        partObj.decision = partObj.decision.toLowerCase() === 'none'
          ? 'part_damage_not_identified'
          : partObj.decision;
        this.loaderText = 'Updating Part Pricing';
        this.isProcessing = true;
        const existingPartObj = this.currentClaim.results.part_pricing.parts.find((item) => item.part_code === partObj.part_code);
        const pricingSummary = this.currentClaim.results.part_pricing.summary;
        if (existingPartObj) {
          pricingSummary.total_part_price = this.convertTwoDecimal(pricingSummary.total_part_price) - this.convertTwoDecimal(existingPartObj.total_part_price);
          pricingSummary.total_labour_price = this.convertTwoDecimal(pricingSummary.total_labour_price) - this.convertTwoDecimal(existingPartObj.total_labour_price);
          pricingSummary.total_labour_hours = this.convertTwoDecimal(pricingSummary.total_labour_hours) - this.convertTwoDecimal(existingPartObj.total_labour_hours);
          pricingSummary.total_paint_price = this.convertTwoDecimal(pricingSummary.total_paint_price) - this.convertTwoDecimal(existingPartObj.total_paint_price);
          pricingSummary.total_paint_hours = this.convertTwoDecimal(pricingSummary.total_paint_hours) - this.convertTwoDecimal(existingPartObj.total_paint_hours);
          pricingSummary.total_material_cost = this.convertTwoDecimal(pricingSummary.total_material_cost) - this.convertTwoDecimal(existingPartObj.total_material_cost);

          pricingSummary.total_internal_part_price = this.convertTwoDecimal(pricingSummary.total_internal_part_price) - this.convertTwoDecimal(existingPartObj.total_internal_part_price);
          pricingSummary.total_internal_labour_price = this.convertTwoDecimal(pricingSummary.total_internal_labour_price) - this.convertTwoDecimal(existingPartObj.total_internal_labour_price);
          pricingSummary.total_internal_labour_hours = this.convertTwoDecimal(pricingSummary.total_internal_labour_hours) - this.convertTwoDecimal(existingPartObj.total_internal_labour_hours);
          pricingSummary.total_internal_paint_price = this.convertTwoDecimal(pricingSummary.total_internal_paint_price) - this.convertTwoDecimal(existingPartObj.total_internal_paint_price);
          pricingSummary.total_internal_paint_hours = this.convertTwoDecimal(pricingSummary.total_internal_paint_hours) - this.convertTwoDecimal(existingPartObj.total_internal_paint_hours);
          pricingSummary.total_internal_material_cost = this.convertTwoDecimal(pricingSummary.total_internal_material_cost) - this.convertTwoDecimal(existingPartObj.total_internal_material_cost);

          pricingSummary.total_net_price = pricingSummary.total_part_price;

          pricingSummary.meta.total_labour_with_gst = this.convertTwoDecimal(pricingSummary.meta.total_labour_with_gst) - this.convertTwoDecimal(existingPartObj.meta.total_labour_with_gst);
          pricingSummary.meta.total_paint_with_gst = this.convertTwoDecimal(pricingSummary.meta.total_paint_with_gst) - this.convertTwoDecimal(existingPartObj.meta.total_paint_with_gst);
          pricingSummary.meta.total_part_with_gst = this.convertTwoDecimal(pricingSummary.meta.total_part_with_gst) - this.convertTwoDecimal(existingPartObj.meta.total_part_with_gst);
          pricingSummary.meta.aux_parts_total_labour_with_gst = this.convertTwoDecimal(pricingSummary.meta.aux_parts_total_labour_with_gst) - this.convertTwoDecimal(existingPartObj.meta.aux_parts_total_labour_with_gst);
          pricingSummary.meta.aux_parts_total_paint_with_gst = this.convertTwoDecimal(pricingSummary.meta.aux_parts_total_paint_with_gst) - this.convertTwoDecimal(existingPartObj.meta.aux_parts_total_paint_with_gst);
          pricingSummary.meta.aux_parts_total_part_with_gst = this.convertTwoDecimal(pricingSummary.meta.aux_parts_total_part_with_gst) - this.convertTwoDecimal(existingPartObj.meta.aux_parts_total_part_with_gst);
          pricingSummary.meta.int_parts_total_labour_with_gst = this.convertTwoDecimal(pricingSummary.meta.int_parts_total_labour_with_gst) - this.convertTwoDecimal(existingPartObj.meta.int_parts_total_labour_with_gst);
          pricingSummary.meta.int_parts_total_paint_with_gst = this.convertTwoDecimal(pricingSummary.meta.int_parts_total_paint_with_gst) - this.convertTwoDecimal(existingPartObj.meta.int_parts_total_paint_with_gst);
          pricingSummary.meta.int_parts_total_part_with_gst = this.convertTwoDecimal(pricingSummary.meta.int_parts_total_part_with_gst) - this.convertTwoDecimal(existingPartObj.meta.int_parts_total_part_with_gst);
        }
        const pricingObj = this.currentClaim.results.part_pricing.parts.filter((item) => item.part_code !== partObj.part_code);

        pricingSummary.total_part_price = this.convertTwoDecimal(pricingSummary.total_part_price) + this.convertTwoDecimal(partObj.total_part_price);
        pricingSummary.total_labour_price = this.convertTwoDecimal(pricingSummary.total_labour_price) + this.convertTwoDecimal(partObj.total_labour_price);
        pricingSummary.total_labour_hours = this.convertTwoDecimal(pricingSummary.total_labour_hours) + this.convertTwoDecimal(partObj.total_labour_hours);
        pricingSummary.total_paint_price = this.convertTwoDecimal(pricingSummary.total_paint_price) + this.convertTwoDecimal(partObj.total_paint_price);
        pricingSummary.total_paint_hours = this.convertTwoDecimal(pricingSummary.total_paint_hours) + this.convertTwoDecimal(partObj.total_paint_hours);
        pricingSummary.total_material_cost = this.convertTwoDecimal(pricingSummary.total_material_cost) + this.convertTwoDecimal(partObj.total_material_cost);

        pricingSummary.total_internal_part_price = this.convertTwoDecimal(pricingSummary.total_internal_part_price) + this.convertTwoDecimal(partObj.total_internal_part_price);
        pricingSummary.total_internal_labour_price = this.convertTwoDecimal(pricingSummary.total_internal_labour_price) + this.convertTwoDecimal(partObj.total_internal_labour_price);
        pricingSummary.total_internal_labour_hours = this.convertTwoDecimal(pricingSummary.total_internal_labour_hours) + this.convertTwoDecimal(partObj.total_internal_labour_hours);
        pricingSummary.total_internal_paint_price = this.convertTwoDecimal(pricingSummary.total_internal_paint_price) + this.convertTwoDecimal(partObj.total_internal_paint_price);
        pricingSummary.total_internal_paint_hours = this.convertTwoDecimal(pricingSummary.total_internal_paint_hours) + this.convertTwoDecimal(partObj.total_internal_paint_hours);
        pricingSummary.total_internal_material_cost = this.convertTwoDecimal(pricingSummary.total_internal_material_cost) + this.convertTwoDecimal(partObj.total_internal_material_cost);

        pricingSummary.total_net_price = pricingSummary.total_part_price;

        pricingSummary.meta.total_labour_with_gst = this.convertTwoDecimal(pricingSummary.meta.total_labour_with_gst) + this.convertTwoDecimal(partObj.meta.total_labour_with_gst);
        pricingSummary.meta.total_paint_with_gst = this.convertTwoDecimal(pricingSummary.meta.total_paint_with_gst) + this.convertTwoDecimal(partObj.meta.total_paint_with_gst);
        pricingSummary.meta.total_part_with_gst = this.convertTwoDecimal(pricingSummary.meta.total_part_with_gst) + this.convertTwoDecimal(partObj.meta.total_part_with_gst);
        pricingSummary.meta.aux_parts_total_labour_with_gst = this.convertTwoDecimal(pricingSummary.meta.aux_parts_total_labour_with_gst) + this.convertTwoDecimal(partObj.meta.aux_parts_total_labour_with_gst);
        pricingSummary.meta.aux_parts_total_paint_with_gst = this.convertTwoDecimal(pricingSummary.meta.aux_parts_total_paint_with_gst) + this.convertTwoDecimal(partObj.meta.aux_parts_total_paint_with_gst);
        pricingSummary.meta.aux_parts_total_part_with_gst = this.convertTwoDecimal(pricingSummary.meta.aux_parts_total_part_with_gst) + this.convertTwoDecimal(partObj.meta.aux_parts_total_part_with_gst);
        pricingSummary.meta.int_parts_total_labour_with_gst = this.convertTwoDecimal(pricingSummary.meta.int_parts_total_labour_with_gst) + this.convertTwoDecimal(partObj.meta.int_parts_total_labour_with_gst);
        pricingSummary.meta.int_parts_total_paint_with_gst = this.convertTwoDecimal(pricingSummary.meta.int_parts_total_paint_with_gst) + this.convertTwoDecimal(partObj.meta.int_parts_total_paint_with_gst);
        pricingSummary.meta.int_parts_total_part_with_gst = this.convertTwoDecimal(pricingSummary.meta.int_parts_total_part_with_gst) + this.convertTwoDecimal(partObj.meta.int_parts_total_part_with_gst);
        pricingSummary.is_transformed = true;

        pricingObj.push(partObj);
        this.currentClaim.results.part_pricing.parts = pricingObj;
        const selectedPart = this.currentClaim.results.vehicle_operations.find(
          (a) => a.part_code === partObj.part_code,
        );
        if (selectedPart && selectedPart.decision !== partObj.decision) {
          const repairReplacePartsExists = this.currentClaim.results.vehicle_operations.filter(
            (a) => a.decision === 'replace' || a.decision === 'repair',
          );
          if (repairReplacePartsExists.length === 1 && (partObj.decision !== 'replace' || partObj.decision !== 'repair')) {
            // eslint-disable-next-line no-param-reassign
            reRunTheClaim = true;
          }
          if (repairReplacePartsExists.length === 0 && (partObj.decision === 'replace' || partObj.decision === 'repair')) {
            // eslint-disable-next-line no-param-reassign
            reRunTheClaim = true;
          }

          if (selectedPart.part_name === 'airbag') {
            // eslint-disable-next-line no-param-reassign
            reRunTheClaim = true;
          }
          selectedPart.decision = partObj.decision;
          if (selectedPart.damages && partObj.decision === 'part_not_identified') {
            selectedPart.damages.ch = 0;
            selectedPart.damages.dent = 0;
            selectedPart.damages.scratch = 0;
            selectedPart.damages.tear = 0;
          }
          selectedPart.is_edited = true;
          const editRequest = {
            feedback_type: 'rr_feedback',
            feedback_source: 'web',
            value: JSON.stringify(this.currentClaim.results.vehicle_operations),
          };
          await this.$http.post(
            `/requests/${this.currentClaim.id}/feedback`,
            editRequest,
          );
          // this.selectedPartDetails.decision = this.selectedPartEdit.decision;
        }
        const editRequest = {
          feedback_type: 'price_feedback',
          feedback_source: 'web',
          value: JSON.stringify(this.currentClaim.results.part_pricing),
        };

        await this.$http.post(
          `/requests/${this.currentClaim.id}/feedback`,
          editRequest,
        );
        this.claimInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
        this.currentClaim.results.repair_estimate = this.getTotalGrossRepairEstimate;
        this.claimInfo.repairabilityStatus = await this.calculateRepairability();// for repairability
        this.currentClaim.results.repairability_status = await this.calculateRepairability();
        // this.aiAnalysisDetails.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate();
        // this.vehicleOtherInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate();
        // this.vehicleInfoRefreshKey = Math.random();
        // this.isProcessing = false;

        if (reRunTheClaim) {
          this.loaderText = 'Fetching Claim Details';
          this.isProcessing = true;
          await this.getClaimDetails();
          // this.illustrationKey = Math.random();
          this.refreshSummaryKey = Math.random();
          this.currentClaim.processing_completed_at = Math.random();
          // this.tabRefreshKey = Math.random();
          this.claimInfoRefreshKey = Math.random();
          this.selectedTab = 0;
          this.isProcessing = false;
        } else {
          this.currentClaim.results.repair_estimate = this.getTotalGrossRepairEstimate;
          // this.aiAnalysisDetails.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
          this.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
          this.claimInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
          this.claimInfo.repairabilityStatus = await this.calculateRepairability();// for repairability
          this.currentClaim.results.repairability_status = await this.calculateRepairability();
          // this.vehicleOtherInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
          // this.geniusAIDetailsRefreshKey = Math.random();
          // this.illustrationKey = Math.random();
          // this.vehicleInfoRefreshKey = Math.random();
          this.refreshSummaryKey = Math.random();
          this.claimInfoRefreshKey = Math.random();
          this.currentClaim.processing_completed_at = Math.random();
          // this.tabRefreshKey = Math.random();
          this.selectedTab = 0;
          this.isProcessing = false;
        }
      }
    },

    async addSelected(dt, index) {
      if (dt && dt.label && dt.label === 'airbag') {
        this.selectedTab = 0;
        const message1 = {
          title: this.$t('confirmation_message.cannot_add_airbag_title'),
          message: this.$t('confirmation_message.cannot_add_airbag_message'),
          confirmText: 'Ok',
          type: 'is-warning',
          iconPack: 'fas',
          hasIcon: true,
        };
        this.$buefy.dialog.alert(message1);
        this.showTooltip = null;
        return false;
      }
      let partFound = false;
      _.forEach(this.tabData, (tabData) => {
        // const allParts = positionWiseParts[tabData.id];
        const allParts = this.getPositionWiseParts[tabData.id];
        const partPresent = _.filter(allParts, (o) => o === dt.label);
        if (partPresent.length > 0) {
          const index1 = _.findIndex(this.tabData, (o) => o.id === tabData.id);
          this.selectedTab = index1 + 1;
          partFound = true;
          this.showTooltip = null;
          return false;
        }
        return true;
      });
      this.imageIndex = 0;
      this.imageIndexKey = Math.random();
      if (!partFound) {
        this.selectedTab = 0;
        const message1 = {
          title: this.$t('detail_view.position_not_found'),
          message: this.$t('detail_view.no_position_found'),
          confirmText: 'Ok',
          type: 'is-warning',
          iconPack: 'fas',
          hasIcon: true,
        };
        this.showTooltip = null;
        setTimeout(() => {
          this.showTooltip = null;
        }, 500);
        this.$buefy.dialog.alert(message1);
      }
      this.showTooltip = index;
      return true;
    },
    async bulkPartPricingUpdated(allPartsObj) {
      if (allPartsObj) {
        this.loaderText = 'Updating Part Pricing';
        this.isProcessing = true;
        let reRunTheClaim = false;
        allPartsObj.parts.forEach((partObj) => {
          const selectedPart = this.currentClaim.results.vehicle_operations.find(
            (a) => a.part_code === partObj.part_code,
          );
          if (selectedPart && selectedPart.decision !== partObj.decision) {
            if (selectedPart.part_name === 'airbag') {
              reRunTheClaim = true;
            }
            selectedPart.decision = partObj.decision;
            if (selectedPart.damages && partObj.decision === 'part_not_identified') {
              selectedPart.damages.ch = 0;
              selectedPart.damages.dent = 0;
              selectedPart.damages.scratch = 0;
              selectedPart.damages.tear = 0;
            }
            selectedPart.is_edited = true;
          }
        });

        const editFeedRequest = {
          feedback_type: 'rr_feedback',
          feedback_source: 'web',
          value: JSON.stringify(this.currentClaim.results.vehicle_operations),
        };
        await this.$http.post(
          `/requests/${this.currentClaim.id}/feedback`,
          editFeedRequest,
        );
        this.currentClaim.results.part_pricing = allPartsObj;
        const editRequest = {
          feedback_type: 'price_feedback',
          feedback_source: 'web',
          value: JSON.stringify(this.currentClaim.results.part_pricing),
        };
        await this.$http.post(
          `/requests/${this.currentClaim.id}/feedback`,
          editRequest,
        );

        if (reRunTheClaim) {
          this.loaderText = 'Fetching Claim Details';
          this.isProcessing = true;
          await this.getClaimDetails();
          this.illustrationKey = Math.random();
          this.refreshSummaryKey = Math.random();
          this.currentClaim.completed_at = Math.random();
        } else {
          this.claimInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
          this.currentClaim.results.repair_estimate = this.getTotalGrossRepairEstimate;
          this.currentClaim.results.repair_estimate = this.getTotalGrossRepairEstimate;
          this.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
          this.claimInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;

          this.claimInfo.repairabilityStatus = await this.calculateRepairability();// for repairability
          this.currentClaim.results.repairability_status = await this.calculateRepairability();

          this.refreshSummaryKey = Math.random();
          this.claimInfoRefreshKey = Math.random();
          this.currentClaim.processing_completed_at = Math.random();
          // this.tabRefreshKey = Math.random();
          this.isProcessing = false;
        }
      }
    },
    // #endregion

    // #region [Action Bar]

    async submitClaimFeedback(feedbackData) {
      this.loaderText = 'Submitting Feedback';
      this.isProcessing = true;
      const response = await this.$http.post(
        `/requests/${this.currentClaim.id}/feedback`,
        {
          feedback_type: feedbackData.feedbackType,
          value: feedbackData.feedback,
        },
      );
      if (response) {
        this.requestStatus = this.feedbackType;
        this.$buefy.toast.open({
          message: this.$t('detail_view.feedback_submitted'),
          type: 'is-success',
        });
        this.isProcessing = false;
        this.PImodal = false;
        this.$router.push({ name: 'ClaimList' });
      }
      this.isProcessing = false;
    },

    async approveClaim() {
      this.$buefy.dialog.confirm({
        title: this.$t('confirmation_message.Approve Claim'),
        message: this.$t('confirmation_message.Are you sure you want to approve the claim?'),
        confirmText: this.$t('confirmation_message.Approve Claim'),
        cancelText: this.$t('confirmation_message.Cancel'),
        type: 'is-warning',
        iconPack: 'fas',
        hasIcon: true,
        onConfirm: async () => {
          this.loaderText = 'Submitting Feedback';
          this.isProcessing = true;
          const response = await this.$http.post(
            `/requests/${this.currentClaim.id}/feedback`,
            {
              feedback_type: 'Approved',
              value: 'Approved',
            },
          );
          if (response) {
            // this.isProcessing = false;
            this.requestStatus = this.feedbackType;
            this.$buefy.toast.open({
              message: this.$t('detail_view.feedback_submitted'),
              type: 'is-success',
            });
            this.PImodal = false;
            this.$router.push({ name: 'ClaimList' });
          }
        },
      });
    },

    async syncToChordys() {
      this.$buefy.dialog.confirm({
        title: this.$t('confirmation_message.sync_to_cordys_title'),
        message: this.$t('confirmation_message.sync_to_cordys_message'),
        confirmText: this.$t('confirmation_message.sync_to_cordys_confirmText'),
        cancelText: this.$t('confirmation_message.sync_to_cordys_cancelText'),
        type: 'is-warning',
        iconPack: 'fas',
        hasIcon: true,
        onConfirm: async () => {
          this.loaderText = 'sync_to_cordys_loaderText';
          this.isProcessing = true;
          const response = await this.$http.get(`/notify-cordys/${this.currentClaim.id}`);
          if (response) {
            this.$buefy.toast.open({
              message: this.$t('confirmation_message.sync_to_cordys_response'),
              type: 'is-success',
            });
            this.isProcessing = false;
          }
        },
      });
    },
    async getRepairabilityStatus() {
      const response = await this.$http.get(
        `claims/${this.currentClaim.id}/get-repairability-status`,
      );
      if (response) {
        return response;
      }

      return 'Reprocess';
    },

    editClaim() {
      this.loaderText = 'redirect_to_edit';
      this.isProcessing = true;
      window.localStorage.setItem('currentClaim', JSON.stringify({
        claimUID: this.currentClaim.uid,
        make: this.currentClaim.make,
        model: this.currentClaim.model,
        year: this.currentClaim.year,
        mileage: this.currentClaim.mileage || 0,
        vehicle_code: this.currentClaim.vehicle_code,
        compulsory_excess: this.currentClaim.compulsory_excess || 0,
        body_type: this.currentClaim.body_type,
        variant: this.currentClaim.variant,
        city_category: this.currentClaim.city_category,
        paint_type: this.currentClaim.paint_type,
      }));
      this.$router.push({
        name: 'ReprocessClaim',
        params: { claimUID: this.$route.params.claimUID },
      });
    },

    // #endregion

    // #region [Estimation Report]
    async showEstimationReport() {
      if (this.isAllNonCar) {
        this.$buefy.toast.open({
          message: this.$t('estimate_renderer.all_non_car_msg'),
          type: 'is-link',
        });
      } else if (this.$cgiSettings.detailsForm.fullEstimate.templateId) {
        this.loaderText = 'Preparing estimate';
        this.isProcessing = true;
        const { config } = this.$cgiSettings.detailsForm.fullEstimate;
        this.estimateFormattedData = await this.$http.post(
          `claims/${this.currentClaim.uid}/${this.currentClaim.id}/${this.$cgiSettings.detailsForm.fullEstimate.convertor}/get-estimate-data/${this.$cgiSettings.detailsForm.fullEstimate.templateId}?timeZoneName=${this.timeZoneName}`,
          config,
        );
        this.isProcessing = false;
      } else {
        // const filteredImages = this.currentClaim.images.filter(a => a.results.isCar !== 'non_car');
        this.estimationMaskedImages = this.currentClaim.results.images.map((a) => ({
          id: a.id,
          url: a.results.damage_masked_image || a.url,
        }));
      }
      if (!this.isAllNonCar) {
        this.showEstimationSummaryOnly = false;
        this.isEstimationReportActive = true;
      }
    },
    async generateEstimate() {
      let estimateFile;
      if (this.$cgiSettings.detailsForm.fullEstimate.templateId) {
        const { config } = this.$cgiSettings.detailsForm.fullEstimate;
        estimateFile = await this.$http.post(
          `claims/${this.currentClaim.uid}/${this.currentClaim.id}/${this.$cgiSettings.detailsForm.fullEstimate.convertor}/generate-pdf-report/${this.$cgiSettings.detailsForm.fullEstimate.templateId}?timeZoneName=${this.timeZoneName}&isWithImage=${this.isWithImage}`,
          config,
          {
            responseType: 'blob',
          },
        );
      } else {
        const data1 = {
          vehicleInfo: _.pick(this.currentClaim, [
            'uid',
            'claim_number',
            'make',
            'model',
            'mileage',
            'year',
            'state',
            'country',
            'vin',
            'loss_year',
            'vehicle_number',
            'registration_date',
            'compulsory_excess',
          ]),
          images: [],
          showNote: this.showNote,
          currency: this.$cgiSettings.currency,
          grossRepairEstimate: {
            totalPartPrice: 0,
            totalLabourCost: 0,
            totalRepairCost: 0,
            totalPaintCost: 0,
            totalInternalPartPrice: 0,
            totalInternalLabourCost: 0,
            totalInternalPaintCost: 0,
            totalDepreciationAmount: 0,
            grossRepairAmount: 0,
            RepairCost: 0,
            compulsoryExcess: 0,
          },
          partSummary: this.damageSummary,
          internalPartList: this.internalPartList,
          depreciationSummary: this.currentClaim.results.part_pricing.summary,
          showSummaryOnly: this.showEstimationSummaryOnly,
          isPDAS: true,
        };

        // const filteredImages = this.currentClaim.images.filter(a => a.results.isCar !== 'non_car');
        data1.images = this.currentClaim.results.images.map((a) => ({
          id: a.id,
          url: a.results.damage_masked_image || a.url,
        }));

        let template = window.localStorage.getItem('region') != null
          && window.localStorage.getItem('region') === 'IN'
          ? 'IN'
          : 'default';
        template = template === 'default' && this.clientId === '54' ? 'UNITPDAS' : this.estimateTemplateId;

        data1.logoUrl = this.clientLogo;
        data1.isLandscape = this.isLandscape;

        estimateFile = await this.$http.post(
          `claims/generate-pdf/${template}?type=pdf&base64=false`,
          {
            data: data1,
          },
          {
            responseType: 'blob',
          },
        );
      // const estimateFile = await this.$http.get(
      //   `claims/${this.currentClaim.uid}/${this.currentClaim.id}/v1/generate-pdf/${template}?type=pdf&base64=false`,
      //   {
      //     responseType: 'blob',
      //   },
      // );
      }
      return estimateFile;
    },

    async downloadPdf() {
      this.loaderText = 'Generating Pdf';
      this.isProcessing = true;
      let estimateFile = await this.generateEstimate();
      this.isProcessing = false;
      saveAs(estimateFile, `${this.currentClaim.uid}.pdf`);
    },
    async downloadExcel() {
      // Construct data object
      const data = {
        vehicleInfo: _.pick(this.currentClaim, [
          'uid',
          'claim_number',
          'make',
          'model',
          'mileage',
          'year',
          'state',
          'country',
          'vin',
          'loss_year',
          'vehicle_number',
          'registration_date',
          'compulsory_excess',
          'acv',
        ]),
      };
      data.vehicleInfo.repairability = this.currentClaim.results.repairability_status;
      data.vehicleInfo.incident_date = this.currentClaim.meta.incident_date ? this.currentClaim.meta.incident_date : this.currentClaim.report_date;
      data.vehicleInfo.incident_location = this.currentClaim.meta.incident_location ? this.currentClaim.meta.incident_location : 'N/A';
      data.vehicleInfo.status = this.$t('claim_listing_data.Open');
      if (this.currentClaim.claimMeta.claim_status_feedback) {
        // const filteredFeedbacks = this.currentClaim.claimMeta.claim_status_feedback.filter((x) => x.feedback_type === 'Approved' || x.feedback_type === 'Rejected' || x.feedback_type === 'Escalated');
        if (this.currentClaim.claimMeta.claim_status_feedback) {
          data.vehicleInfo.status = this.$t(`claim_listing_data.${this.currentClaim.claimMeta.claim_status_feedback.feedback_type}`);
        }
      }

      if (data.vehicleInfo.acv === null) data.vehicleInfo.acv = 0.00;

      let totalRepairCost = 0;
      const partsData = [];
      const filteredParts = this.damageSummary.filter((a) => a.decision !== 'None' && a.decision !== 'part_not_identified' && a.decision !== 'part_damage_not_identified');
      const internalPartList = this.internalPartList || [];
      filteredParts.forEach((part) => {
        const mainPart = _.omit(part.items, ['auxiliary_parts', 'internal_parts']);
        const auxParts = _.map(_.filter(part.items.auxiliary_parts || [], ['is_selected', true]), (a) => _.extend({ type: 'Auxiliary' }, a));
        const internalParts = [];// _.map(internalPartList || [], (a) => _.extend({ type: 'Internal' }, a));
        const allParts = _.concat(auxParts, internalParts);
        allParts.unshift(mainPart);

        allParts.forEach((auxPart) => {
          // if (auxPart.decision === 'replace' || (auxPart.decision === 'repair' && auxPart.is_main_part)) {
          if (auxPart.decision === 'replace' || auxPart.decision === 'repair') {
            // if (auxPart.is_main_part || (!auxPart.is_main_part && auxPart.part_price > 0)) {
            const partInfo = {
              // primary_part: auxPart.is_main_part ? this.$options.filters.partname(auxPart.part_std_name) : auxPart.part_name,
              primary_part: auxPart.part_name,
              decision: this.$options.filters.titlecase(this.$t(`excel_report.${auxPart.decision}`)),
              part_type: (auxPart.is_main_part ? this.$t('excel_report.Primary') : auxPart.type), // this.$t('excel_report.Auxiliary')),
              part_name: auxPart.part_name,
              metallurgy: auxPart.metallurgy,
              quantity: parseInt(auxPart.quantity || 0, 10),
              part_price: parseFloat(auxPart.part_price || 0),
              gst: parseFloat(auxPart.gst || 0),
              total_part_cost: parseFloat(auxPart.meta.total_part_with_gst || 0),
              labour_rate: parseFloat(auxPart.labour_rate || 0),
              dent_time: parseFloat(auxPart.dent_hours || 0),
              labour_time: parseFloat(auxPart.labour_hours || 0),
              labour_price: parseFloat(auxPart.meta.total_labour_with_gst || 0),
              paint_rate: parseFloat(auxPart.paint_rate || 0),
              material_cost: parseFloat(auxPart.material_cost || 0),
              paint_price: parseFloat(auxPart.meta.total_paint_with_gst || 0),
              total_price: parseFloat(auxPart.meta.total_part_with_gst || 0) + parseFloat(auxPart.meta.total_labour_with_gst || 0) + parseFloat(auxPart.meta.total_paint_with_gst || 0),
            };
            // if (partInfo.primary_part.toLowerCase() === 'airbag') {
            //   partInfo.part_price = 2950; // Hard coded price for airbag based on Mike's feedback
            //   partInfo.total_price += partInfo.part_price;
            // }
            partsData.push([partInfo.primary_part, partInfo.decision, partInfo.part_type, partInfo.part_name, partInfo.metallurgy, partInfo.quantity, partInfo.part_price, partInfo.gst, partInfo.total_part_cost, partInfo.labour_rate, partInfo.dent_time, partInfo.labour_time, partInfo.labour_price, partInfo.paint_rate, partInfo.material_cost, partInfo.paint_price, partInfo.total_price]);
            // }
            totalRepairCost += partInfo.total_price;
          }
        });
      });
      internalPartList.forEach((intPart) => {
        // if (intPart.decision === 'replace' || (intPart.decision === 'repair' && intPart.is_main_part)) {
        if ((intPart.decision === 'replace' || intPart.decision === 'repair') && intPart.is_selected === true) {
          // if (auxPart.is_main_part || (!auxPart.is_main_part && auxPart.part_price > 0)) {
          const partInfo = {
            // primary_part: auxPart.is_main_part ? this.$options.filters.partname(auxPart.part_std_name) : auxPart.part_name,
            primary_part: intPart.part_name,
            decision: this.$options.filters.titlecase(this.$t(`excel_report.${intPart.decision}`)),
            part_type: (intPart.is_main_part ? this.$t('excel_report.Primary') : intPart.type), // this.$t('excel_report.Auxiliary')),
            part_name: intPart.part_name,
            metallurgy: intPart.metallurgy,
            quantity: parseInt(intPart.quantity || 0, 10),
            part_price: parseFloat(intPart.part_price || 0),
            gst: parseFloat(intPart.gst || 0),
            total_part_cost: parseFloat(intPart.meta.total_part_with_gst || 0),
            labour_rate: parseFloat(intPart.labour_rate || 0),
            dent_time: parseFloat(intPart.dent_hours || 0),
            labour_time: parseFloat(intPart.labour_hours || 0),
            labour_price: parseFloat(intPart.meta.total_labour_with_gst || 0),
            paint_rate: parseFloat(intPart.paint_rate || 0),
            material_cost: parseFloat(intPart.material_cost || 0),
            paint_price: parseFloat(intPart.meta.total_paint_with_gst || 0),
            total_price: parseFloat(intPart.meta.total_part_with_gst || 0) + parseFloat(intPart.meta.total_labour_with_gst || 0) + parseFloat(intPart.meta.total_paint_with_gst || 0),
          };
          // if (partInfo.primary_part.toLowerCase() === 'airbag') {
          //   partInfo.part_price = 2950; // Hard coded price for airbag based on Mike's feedback
          //   partInfo.total_price += partInfo.part_price;
          // }
          partsData.push([partInfo.primary_part, partInfo.decision, partInfo.part_type, partInfo.part_name, partInfo.metallurgy, partInfo.quantity, partInfo.part_price, partInfo.gst, partInfo.total_part_cost, partInfo.labour_rate, partInfo.dent_time, partInfo.labour_time, partInfo.labour_price, partInfo.paint_rate, partInfo.material_cost, partInfo.paint_price, partInfo.total_price]);
          // }
          totalRepairCost += partInfo.total_price;
        }
      });

      // Fix - If not parts identified - Add an empty row to print the table with formatting
      if (partsData.length === 0) {
        const partInfo = {
          primary_part: 'No part available',
          decision: '',
          part_type: '',
          part_name: '',
          metallurgy: '',
          quantity: 0,
          part_price: 0.00,
          gst: 0.00,
          total_part_cost: 0.00,
          labour_rate: 0.00,
          dent_time: 0,
          labour_time: 0,
          labour_price: 0.00,
          paint_rate: 0.00,
          material_cost: 0,
          paint_price: 0.00,
          total_price: 0.00,
        };
        partsData.push([partInfo.primary_part, partInfo.decision, partInfo.part_type, partInfo.part_name, partInfo.metallurgy, partInfo.quantity, partInfo.part_price, partInfo.gst, partInfo.total_part_cost, partInfo.labour_rate, partInfo.dent_time, partInfo.labour_time, partInfo.labour_price, partInfo.paint_rate, partInfo.material_cost, partInfo.paint_price, partInfo.total_price]);
      }

      // alert('Report in excel will be downloaded shortly...');
      const workbook = new Excel.Workbook();

      // Set workbook dates to 1904 date system
      workbook.properties.date1904 = true;

      // create new sheet with pageSetup settings for A4 - landscape
      const worksheet = workbook.addWorksheet('sheet1', {
        pageSetup: { paperSize: 9, orientation: 'portrait' },
      });

      // merge A1-B1 for title
      worksheet.mergeCells('A1:B1');

      // Set title and font for title
      worksheet.getCell('A1').value = this.$t('excel_report.claim_export');
      worksheet.getCell('A1').font = {
        name: 'Ariel',
        family: 2,
        size: 12,
        bold: true,
      };

      // ------------------- First table with summary ----------------------
      worksheet.getCell('A3').value = this.$t('excel_report.export_time');
      worksheet.getCell('A4').value = this.$t('excel_report.claim_id');
      worksheet.getCell('A5').value = this.$t('excel_report.reference_id');
      worksheet.getCell('A6').value = this.$t('excel_report.make');
      worksheet.getCell('A7').value = this.$t('excel_report.model');
      worksheet.getCell('A8').value = this.$t('excel_report.year');
      worksheet.getCell('A9').value = this.$t('excel_report.vin');
      worksheet.getCell('A10').value = this.$t('excel_report.license');
      worksheet.getCell('A11').value = this.$t('excel_report.insured_state');
      worksheet.getCell('A12').value = this.$t('excel_report.incident_date');
      worksheet.getCell('A13').value = this.$t('excel_report.incident_location');
      worksheet.getCell('A14').value = this.$t('excel_report.odometer');
      worksheet.getCell('A15').value = this.$t('excel_report.acv');
      worksheet.getCell('A16').value = this.$t('excel_report.repair_cost');
      worksheet.getCell('A17').value = this.$t('excel_report.repairability');
      worksheet.getCell('A18').value = this.$t('excel_report.status');

      worksheet.getCell('B3').value = new Date();
      worksheet.getCell('B4').value = data.vehicleInfo.uid;
      worksheet.getCell('B5').value = data.vehicleInfo.claim_number;
      worksheet.getCell('B6').value = data.vehicleInfo.make;
      worksheet.getCell('B7').value = data.vehicleInfo.model;
      worksheet.getCell('B8').value = data.vehicleInfo.year;
      worksheet.getCell('B9').value = data.vehicleInfo.vin;
      worksheet.getCell('B10').value = '';
      if (data.vehicleInfo.state === 'ZZ') {
        worksheet.getCell('B11').value = '';
      } else {
        worksheet.getCell('B11').value = data.vehicleInfo.state;
      }

      worksheet.getCell('B12').value = new Date(data.vehicleInfo.incident_date);
      worksheet.getCell('B13').value = data.vehicleInfo.incident_location;
      worksheet.getCell('B14').value = data.vehicleInfo.mileage;
      worksheet.getCell('B15').value = data.vehicleInfo.acv;
      worksheet.getCell('B16').value = parseFloat(totalRepairCost);// `${this.$cgiSettings.currency} ${totalRepairCost.toFixed(2)}`;
      worksheet.getCell('B17').value = data.vehicleInfo.repairability;
      worksheet.getCell('B18').value = data.vehicleInfo.status;

      worksheet.getCell('B4').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B5').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B6').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B7').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B8').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B9').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B10').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B11').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B12').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B13').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B14').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B15').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B16').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B17').alignment = { vertical: 'middle', horizontal: 'right' };
      worksheet.getCell('B18').alignment = { vertical: 'middle', horizontal: 'right' };

      // set single thin border around A1
      worksheet.getCell('A3').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A3').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A4').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A5').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A6').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A7').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A8').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A9').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A10').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A11').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A12').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A13').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A14').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A15').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A16').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A17').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('A18').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };

      worksheet.getCell('B3').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B4').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B5').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B6').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B7').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B8').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B9').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B10').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B11').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B12').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B13').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B14').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B15').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B16').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B17').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };
      worksheet.getCell('B18').border = {
        top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' },
      };

      worksheet.getCell('B15').numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getCell('B16').numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      // link to web
      // worksheet.getCell('B4').value = {
      //   text: data.vehicleInfo.uid,
      //   hyperlink: `http://gc.claimgenius.com/claims/${data.vehicleInfo.uid}`,
      //   tooltip: 'Claim Genius Dashboard',
      // };
      worksheet.getCell('B4').value = data.vehicleInfo.uid;
      // ------------------------------Main Header-----------------------------
      // worksheet.mergeCells('F21:H21');
      // worksheet.getCell('G21').value = 'Parts';
      // worksheet.getCell('G21').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      // ------------------- second table with parts -----------------------
      // add a table to a sheet
      worksheet.addTable({
        name: 'PartsDetails',
        ref: 'A22',
        headerRow: true,
        totalsRow: true,
        style: {
          theme: 'TableStyleMedium9',
          showRowStripes: false,
        },
        columns: [
          { name: this.$t('excel_report.primary_part'), totalsRowLabel: 'Total:', filterButton: true },
          { name: this.$t('excel_report.decision'), filterButton: true },
          { name: this.$t('excel_report.part_type'), filterButton: true },
          { name: this.$t('excel_report.part_name'), filterButton: false },
          { name: this.$t('excel_report.metallurgy'), filterButton: true },
          { name: this.$t('excel_report.quantity'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.part_price'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.gst'), totalsRowFunction: 'none', filterButton: false },
          { name: this.$t('excel_report.total_part_price'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.labour_rate'), filterButton: false },
          { name: this.$t('excel_report.dent_hours'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.labour_hours'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.labour_price'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.paint_rate'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.material_cost'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.paint_price'), totalsRowFunction: 'sum', filterButton: false },
          { name: this.$t('excel_report.total_price'), totalsRowFunction: 'sum', filterButton: false },
        ],
        rows: partsData,
      });

      worksheet.getColumn(7).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      // worksheet.getColumn(7).numFmt = '0"%"';
      // worksheet.getColumn(8).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(9).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(11).numFmt = `""#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(12).numFmt = `""#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(13).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(14).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(15).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(16).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;
      worksheet.getColumn(17).numFmt = `"${this.$cgiSettings.currency}"#,##0.00;[Red]-"${this.$cgiSettings.currency}"#,##0.00`;

      worksheet.getColumn('A').width = 25;
      worksheet.getColumn('B').width = 25;
      worksheet.getColumn('C').width = 15;
      worksheet.getColumn('D').width = 35;
      worksheet.getColumn('E').width = 15;
      worksheet.getColumn('F').width = 15;
      worksheet.getColumn('G').width = 15;
      worksheet.getColumn('H').width = 15;
      worksheet.getColumn('I').width = 15;
      worksheet.getColumn('J').width = 15;
      worksheet.getColumn('K').width = 15;
      worksheet.getColumn('L').width = 15;
      worksheet.getColumn('M').width = 15;
      worksheet.getColumn('N').width = 15;
      worksheet.getColumn('O').width = 15;

      // Issue BUG-122 resolution
      worksheet.getCell('F22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('G22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('H22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('I22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('J22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('K22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('L22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('M22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('N22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('O22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('P22').font = { color: { argb: 'FFFFFFFF' } };
      worksheet.getCell('Q22').font = { color: { argb: 'FFFFFFFF' } };

      const downloadFileName = `ClaimDetails-${data.vehicleInfo.uid}`;
      // Save XLSX
      workbook.xlsx.writeBuffer().then((data1) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const fileExtension = '.xlsx';

        const blob = new Blob([data1], { type: fileType });

        saveAs(blob, downloadFileName + fileExtension);
      });
    },
    closePrintPopUp() {
      this.showPrintReportWithImageModal = false;
    },
    print() {
      if (this.isPrintReportImageModalEnable) {
        this.isWithImage = true;
        this.showPrintReportWithImageModal = true;
      } else {
        this.preparePrintData();
      }
    },
    async preparePrintData() {
      this.showPrintReportWithImageModal = false;
      if (this.isAllNonCar) {
        this.$buefy.toast.open({
          message: this.$t('estimate_renderer.all_non_car_msg'),
          type: 'is-link',
        });
      } else {
        this.loaderText = 'Preparing estimate to print';
        this.isProcessing = true;
        const estimateFile = await this.generateEstimate();
        this.isProcessing = false;
        if (estimateFile) {
          let base64data = null;
          const reader = new FileReader();
          reader.readAsDataURL(estimateFile);
          reader.onloadend = () => {
            base64data = reader.result;
            base64data = base64data.slice(base64data.indexOf(',') + 1);
            printJS({
              printable: base64data,
              type: 'pdf',
              base64: true,
            // css:['https://unpkg.com/buefy@0.9.2/dist/buefy.min.css'],
            // style: this.cssText
            });
          };
        }
      }
    },
    // #endregion

    // #region [Damage Annotation]

    // When new featuer is added then => imageFeatures.operation = 'addFeature'
    // When any featuer is updated then => imageFeatures.operation = 'editFeature'
    // When any featuer is deleted then => imageFeatures.operation = 'removeFeature'
    async saveAnnotation(imageFeatures) {
      this.selectedPartName = null;
      if (imageFeatures.type) {
        this.showLoader(imageFeatures);
        // eslint-disable-next-line camelcase
        const { vehicle_operations } = this.currentClaim.results;
        const vehicleOperationsBackup = JSON.parse(JSON.stringify(vehicle_operations));
        const noDamegeObject = {
          dent: 0, scratch: 0, tear: 0, ch: 0, pp: 0, part_area: 0, dent_damage_threshold: 0, scratch_damage_threshold: 0, tear_damage_threshold: 0,
        };
        let isLastPart = false;
        let lastPartName = null;
        const allFeatures = {
          parts: 'parts',
          dent: 'dent',
          scratch: 'scratch',
          tear: 'ch',
        };
        const feat = {
          features: [],
        };
        this.showParts = false;
        const part = {};
        // Add Feature Start.
        // If imageFeatures.type is not 'Part' then we are saving all damages irrespective of the damage added.
        // If user added scratch then also we are saving Scratch, Dent and Tear polygons.
        if (
          imageFeatures.type !== 'parts'
          && imageFeatures.operation !== 'editFeature'
        ) {
          const stdModels = ['scratch', 'dent', 'tear'];
          const allSaveOps = [];
          stdModels.forEach(async (model) => {
            allSaveOps.push(
              this.saveFormatedDamagePolygons(imageFeatures, model),
            );
          });
          await Promise.all(allSaveOps);
          if (imageFeatures.operation === 'removeFeature') {
            await this.saveDeleteFeedback(imageFeatures, imageFeatures.type);
          }
        } else if (
          imageFeatures.type === 'parts'
          && imageFeatures.operation !== 'editFeature'
        ) {
          const features = imageFeatures.features.find(
            (a) => a.name === imageFeatures.type,
          );

          if (
            features.features.length === 0
            && imageFeatures.operation === 'removeFeature'
          ) {
            isLastPart = true;
            lastPartName = imageFeatures.featureId;
            this.deleteAllDamages(imageFeatures.imageId);
          }

          features.features.forEach((oneFeature) => {
            feat.features.push({
              class_id: 0,
              label:
                imageFeatures.type === 'parts'
                  ? oneFeature.meta.label
                  : allFeatures[imageFeatures.type],
              meta: oneFeature.meta,
              points: oneFeature.coordinates,
              roi: [0, 0, 0, 0],
              scores: 1,
            });

            // imageFeatures.featureId is the Id of the part which is currently added.
            // We are creating the object of newly added part so that we can add or modify the same part to rr_prediction object.
            if (oneFeature.name === imageFeatures.featureId) {
              part.part_name = oneFeature.meta.label;
              part.standard_part_name = oneFeature.meta.label;
              part.decision = oneFeature.meta.decision;
            }
          });
          await this.saveFeatures(
            imageFeatures.type,
            imageFeatures.imageId,
            feat,
          );
        } else if (
          imageFeatures.type === 'parts'
          && imageFeatures.operation === 'editFeature'
        ) {
          const features = imageFeatures.features.find(
            (a) => a.name === imageFeatures.type,
          );
          const updatedPart = _.find(
            features.features,
            (x) => x.name === imageFeatures.featureId,
          );
          this.selectedPartEdit.part_name = updatedPart.meta.label;
          this.selectedPartEdit.decision = updatedPart.meta.decision;
          const selectedPart = vehicle_operations.find(
            (a) => a.part_name === this.selectedPartEdit.part_name,
          );
          await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: this.selectedPartEdit.decision, part_name: selectedPart.name }, true);
        }
        // Add Feature End.

        // If new part is added or updated (only meta can be update)
        if ( // This is modified
          part
          && imageFeatures.type === 'parts'
          && imageFeatures.operation === 'addFeature'
        ) {
          const features = imageFeatures.features.find(
            (a) => a.name === imageFeatures.type,
          );
          const updatedPart = _.find(
            features.features,
            (x) => x.name === imageFeatures.featureId,
          );
          const { decision } = updatedPart.meta;
          const dt = await this.recalculateRRPrdiction(
            imageFeatures.imageId,
            { isLastPart, partName: lastPartName },
          );
          if (dt && dt.length > 0) {
            let saveVehicleOperations = false;
            let updatePricingFor = [];
            dt.forEach((onepart) => {
              const partExistFromBackup = vehicleOperationsBackup.find(
                (a) => a.part_name === onepart.part_name,
              );
              const currentPartInVehicleOPerations = vehicle_operations.find(
                (a) => a.part_name === onepart.part_name,
              );
              if (!this.glassParts.includes(onepart.part_name) && onepart.part_name !== 'airbag') {
                if (partExistFromBackup) {
                  if (Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length > 0) {
                    if ((partExistFromBackup.damages.scratch || 0) === (onepart.damages.scratch || 0)
                      && (partExistFromBackup.damages.dent || 0) === (onepart.damages.dent || 0)
                      && (partExistFromBackup.damages.tear || 0) === (onepart.damages.tear || 0)
                      && (partExistFromBackup.damages.dent_damage_threshold || 0) === (onepart.damages.dent_damage_threshold || 0)) {
                      // do nothing
                    } else if (currentPartInVehicleOPerations) {
                      currentPartInVehicleOPerations.damages = onepart.damages;
                      if (onepart.damages.scratch === 0
                        && onepart.damages.dent === 0
                        && onepart.damages.tear === 0
                      ) {
                        if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                          currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                          saveVehicleOperations = true;
                          updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                        }
                      } else if (currentPartInVehicleOPerations.decision === 'part_damage_not_identified') {
                        currentPartInVehicleOPerations.decision = 'repair';
                        saveVehicleOperations = true;
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'repair' });
                      }
                    }
                  } else if (Object.keys(partExistFromBackup.damages).length === 0 && Object.keys(onepart.damages).length > 0) {
                    currentPartInVehicleOPerations.damages = onepart.damages;
                    if (onepart.damages.scratch === 0
                      && onepart.damages.dent === 0
                      && onepart.damages.tear === 0
                    ) {
                      if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                        currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                        saveVehicleOperations = true;
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                      }
                    } else if (currentPartInVehicleOPerations.decision === 'part_damage_not_identified') {
                      currentPartInVehicleOPerations.decision = 'repair';
                      saveVehicleOperations = true;
                      updatePricingFor.push({ part_name: onepart.part_name, decision: 'repair' });
                    }
                  } else if (Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length === 0) {
                    currentPartInVehicleOPerations.damages = {};
                    saveVehicleOperations = true;
                    if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                      currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                      updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                    }
                  }
                }
              }

              // commented below code because after adding part it will give new extra parts with none decision

              // else if (partExistFromBackup && Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length > 0) {
              //   if (onepart.decision !== partExistFromBackup.decision) {
              //     currentPartInVehicleOPerations.decision = onepart.decision;
              //     currentPartInVehicleOPerations.damages = onepart.damages;
              //     saveVehicleOperations = true;
              //     updatePricingFor.push({ part_name: onepart.part_name, decision: onepart.decision });
              //   }
              // }

              if (currentPartInVehicleOPerations.decision !== decision) {
                if (onepart.part_name === updatedPart.meta.label) {
                  currentPartInVehicleOPerations.decision = decision;
                }

                saveVehicleOperations = true;
                if (updatePricingFor.length > 0) {
                  updatePricingFor = updatePricingFor.filter((a) => a.part_name !== onepart.part_name);
                  updatePricingFor.push({ part_name: onepart.part_name, decision });
                } else {
                  updatePricingFor.push({ part_name: onepart.part_name, decision });
                }
              }
            });
            const saveFeedback = [];
            if (saveVehicleOperations && updatePricingFor.length === 0) {
              await this.saveVehicleOperationsAfterUpdate(vehicle_operations);
              await this.reRunTheClaim(imageFeatures);
            } else {
              saveFeedback.push(this.saveVehicleOperationsAfterUpdate(vehicle_operations));
            }
            if (updatePricingFor.length > 0) {
              const parts = [];
              const pricingFilters = {};
              if (this.currentClaim.paint_type) {
                pricingFilters.paint_type = this.currentClaim.paint_type;
              }
              if (this.currentClaim.city_category) {
                pricingFilters.city_category = this.currentClaim.city_category;
              }
              updatePricingFor.forEach((element) => {
                const selectedPart = vehicle_operations.find(
                  (a) => a.part_name === element.part_name,
                );
                parts.push({
                  part_code: selectedPart.part_code,
                  decision: selectedPart.decision,
                  damages: selectedPart.damages,
                  internal_parts: _.map(selectedPart.smart_association_internal, (a) => _.pick(a, ['part_code', 'decision'])),
                });
              });

              const partObj = {
                claim_id: this.currentClaim.id,
                vehicle_code: this.currentClaim.vehicle_code,
                include_aux_parts: true,
                language_code: this.languageCode,
                parts,
                filters: pricingFilters,
              };
              const pricingOutput = await this.$http.post(
                '202103/pricing/part-price',
                partObj,
              );

              const allPartsUpdatedOutput = [];
              if (pricingOutput && pricingOutput.parts && pricingOutput.parts.length > 0) {
                this.isProcessing = true;
                allPartsUpdatedOutput.push(this.multiPartPricingUpdate(pricingOutput));
                await Promise.all(allPartsUpdatedOutput);
                saveFeedback.push(this.savePricingAfterUpdate(this.currentClaim.results.part_pricing));
                await Promise.all(saveFeedback);
                await this.reRunTheClaim(imageFeatures);
              }
            } else {
              // this.currentClaim.processing_completed_at = Math.random();
              // this.selectedTab = 0;
              // this.isProcessing = false;
              await this.reRunTheClaim(imageFeatures);
            }
          }
        } else if ( // This is modified
          imageFeatures.type !== 'parts'
          && imageFeatures.operation !== 'editFeature'
        ) {
          const dt = await this.recalculateRRPrdiction(
            imageFeatures.imageId,
            { isLastPart, partName: lastPartName },
          );
          if (dt && dt.length > 0) {
            let saveVehicleOperations = false;
            let updatePricingFor = [];
            dt.forEach((onepart) => {
              if (!this.glassParts.includes(onepart.part_name) && onepart.part_name !== 'airbag') {
                const partExistFromBackup = vehicleOperationsBackup.find(
                  (a) => a.part_name === onepart.part_name,
                );
                const currentPartInVehicleOPerations = vehicle_operations.find(
                  (a) => a.part_name === onepart.part_name,
                );
                if (partExistFromBackup) {
                  if (Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length > 0) {
                    if (partExistFromBackup.damages.scratch === onepart.damages.scratch
                      && partExistFromBackup.damages.dent === onepart.damages.dent
                      && partExistFromBackup.damages.tear === onepart.damages.tear
                      && partExistFromBackup.damages.dent_damage_threshold === onepart.damages.dent_damage_threshold) {
                      // Do nothing
                    } else if (currentPartInVehicleOPerations) {
                      currentPartInVehicleOPerations.damages = onepart.damages;
                      saveVehicleOperations = true;
                      if (onepart.damages.scratch === 0
                        && onepart.damages.dent === 0
                        && onepart.damages.tear === 0
                      ) {
                        if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                          currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                          saveVehicleOperations = true;
                          updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                        }
                      } else if (currentPartInVehicleOPerations.decision === 'part_damage_not_identified') {
                        currentPartInVehicleOPerations.decision = 'repair';
                        saveVehicleOperations = true;
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'repair' });
                      }

                      // check if dent calculation change
                      if (partExistFromBackup.damages.dent_damage_threshold !== onepart.damages.dent_damage_threshold) {
                        saveVehicleOperations = true;
                        if (updatePricingFor.length > 0) {
                          updatePricingFor = updatePricingFor.filter((a) => a.part_name !== onepart.part_name);
                          updatePricingFor.push({ part_name: onepart.part_name, decision: currentPartInVehicleOPerations.decision });
                        } else {
                          updatePricingFor.push({ part_name: onepart.part_name, decision: currentPartInVehicleOPerations.decision });
                        }
                      }
                    }
                  } else if (Object.keys(partExistFromBackup.damages).length === 0 && Object.keys(onepart.damages).length > 0) {
                    currentPartInVehicleOPerations.damages = onepart.damages;
                    if (onepart.damages.scratch === 0
                      && onepart.damages.dent === 0
                      && onepart.damages.tear === 0
                    ) {
                      if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                        currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                        saveVehicleOperations = true;
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                      }
                    } else if (currentPartInVehicleOPerations.decision === 'part_damage_not_identified') {
                      currentPartInVehicleOPerations.decision = 'repair';
                      saveVehicleOperations = true;
                      updatePricingFor.push({ part_name: onepart.part_name, decision: 'repair' });
                    }
                  } else if (Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length === 0) {
                    currentPartInVehicleOPerations.damages = {};
                    saveVehicleOperations = true;
                    if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                      currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                      updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                    }
                  }
                }
              }
            });
            const saveFeedback = [];
            if (saveVehicleOperations && updatePricingFor.length === 0) {
              await this.saveVehicleOperationsAfterUpdate(vehicle_operations);
              await this.reRunTheClaim(imageFeatures);
            } else {
              saveFeedback.push(this.saveVehicleOperationsAfterUpdate(vehicle_operations));
            }
            if (updatePricingFor.length > 0) {
              const parts = [];
              const pricingFilters = {};
              if (this.currentClaim.paint_type) {
                pricingFilters.paint_type = this.currentClaim.paint_type;
              }
              if (this.currentClaim.city_category) {
                pricingFilters.city_category = this.currentClaim.city_category;
              }
              updatePricingFor.forEach((element) => {
                const selectedPart = vehicle_operations.find(
                  (a) => a.part_name === element.part_name,
                );
                parts.push({
                  part_code: selectedPart.part_code,
                  decision: selectedPart.decision,
                  damages: selectedPart.damages,
                  internal_parts: _.map(selectedPart.smart_association_internal, (a) => _.pick(a, ['part_code', 'decision'])),
                });
              });

              const partObj = {
                claim_id: this.currentClaim.id,
                vehicle_code: this.currentClaim.vehicle_code,
                include_aux_parts: true,
                language_code: this.languageCode,
                parts,
                filters: pricingFilters,
              };
              const pricingOutput = await this.$http.post(
                '202103/pricing/part-price',
                partObj,
              );

              const allPartsUpdatedOutput = [];
              if (pricingOutput && pricingOutput.parts && pricingOutput.parts.length > 0) {
                this.isProcessing = true;
                allPartsUpdatedOutput.push(this.multiPartPricingUpdate(pricingOutput));
                await Promise.all(allPartsUpdatedOutput);
                saveFeedback.push(this.savePricingAfterUpdate(this.currentClaim.results.part_pricing));
                await Promise.all(saveFeedback);
                // await Promise.all(saveFeedback).then((values) => {
                //   console.log(values);
                // }).catch((reason) => {
                //   console.log(reason);
                // });
                await this.reRunTheClaim(imageFeatures);
              }
            } else {
              // this.currentClaim.processing_completed_at = Math.random();
              // this.selectedTab = 0;
              // this.isProcessing = false;
              await this.reRunTheClaim(imageFeatures);
            }
          }
        } else if (
          imageFeatures.type === 'parts'
          && imageFeatures.operation === 'removeFeature'
        ) {
          const deletedPart = imageFeatures.polygonToBeDeleted.meta.part;
          const dt = await this.recalculateRRPrdiction(
            imageFeatures.imageId,
            { isLastPart, partName: lastPartName },
          );
          if (dt && dt.length > 0) {
            const deletedPartExist = dt.find((a) => a.part_name === deletedPart);
            let saveVehicleOperations = false;
            const updatePricingFor = [];
            if (deletedPartExist) {
              dt.forEach((onepart) => {
                if (!this.glassParts.includes(onepart.part_name) && onepart.part_name !== 'airbag') {
                  const partExistFromBackup = vehicleOperationsBackup.find(
                    (a) => a.part_name === onepart.part_name,
                  );
                  const currentPartInVehicleOPerations = vehicle_operations.find(
                    (a) => a.part_name === onepart.part_name,
                  );
                  if (partExistFromBackup) {
                    if (Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length > 0) {
                      if (onepart.decision === 'part_not_identified') {
                        currentPartInVehicleOPerations.decision = 'part_not_identified';
                        currentPartInVehicleOPerations.damages = noDamegeObject;
                        saveVehicleOperations = true;
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_not_identified' });
                      } else if ((partExistFromBackup.damages.scratch || 0) === (onepart.damages.scratch || 0)
                        && (partExistFromBackup.damages.dent || 0) === (onepart.damages.dent || 0)
                        && (partExistFromBackup.damages.tear || 0) === (onepart.damages.tear || 0)
                        && (partExistFromBackup.damages.dent_damage_threshold || 0) === (onepart.damages.dent_damage_threshold || 0)) {
                        // do nothing
                      } else if (currentPartInVehicleOPerations) {
                        currentPartInVehicleOPerations.damages = onepart.damages;
                        if (onepart.damages.scratch === 0
                          && onepart.damages.dent === 0
                          && onepart.damages.tear === 0
                        ) {
                          if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                            currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                            saveVehicleOperations = true;
                            updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                          }
                        } else if (currentPartInVehicleOPerations.decision === 'part_damage_not_identified') {
                          currentPartInVehicleOPerations.decision = 'repair';
                          saveVehicleOperations = true;
                          updatePricingFor.push({ part_name: onepart.part_name, decision: 'repair' });
                        }
                      }
                    } else if (Object.keys(partExistFromBackup.damages).length === 0 && Object.keys(onepart.damages).length > 0) {
                      currentPartInVehicleOPerations.damages = onepart.damages;
                      if (onepart.damages.scratch === 0
                        && onepart.damages.dent === 0
                        && onepart.damages.tear === 0
                      ) {
                        if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                          currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                          saveVehicleOperations = true;
                          updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                        }
                      } else if (currentPartInVehicleOPerations.decision === 'part_damage_not_identified') {
                        currentPartInVehicleOPerations.decision = 'repair';
                        saveVehicleOperations = true;
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'repair' });
                      }
                    } else if (Object.keys(partExistFromBackup.damages).length > 0 && Object.keys(onepart.damages).length === 0) {
                      currentPartInVehicleOPerations.damages = {};
                      saveVehicleOperations = true;
                      if (currentPartInVehicleOPerations.decision !== 'part_damage_not_identified') {
                        currentPartInVehicleOPerations.decision = 'part_damage_not_identified';
                        updatePricingFor.push({ part_name: onepart.part_name, decision: 'part_damage_not_identified' });
                      }
                    }
                  }
                } else {
                  const currentPartInVehicleOPerations = vehicle_operations.find(
                    (a) => a.part_name === deletedPart,
                  );
                  currentPartInVehicleOPerations.decision = 'part_not_identified';
                  currentPartInVehicleOPerations.damages = noDamegeObject;
                  saveVehicleOperations = true;
                  updatePricingFor.push({ part_name: deletedPart, decision: 'part_not_identified' });
                }
              });
            } else {
              const currentPartInVehicleOPerations = vehicle_operations.find(
                (a) => a.part_name === deletedPart,
              );
              currentPartInVehicleOPerations.decision = 'part_not_identified';
              currentPartInVehicleOPerations.damages = noDamegeObject;
              saveVehicleOperations = true;
              updatePricingFor.push({ part_name: deletedPart, decision: 'part_not_identified' });
            }
            const saveFeedback = [];
            if (saveVehicleOperations && updatePricingFor.length === 0) {
              await this.saveVehicleOperationsAfterUpdate(vehicle_operations);
              await this.reRunTheClaim(imageFeatures);
            } else {
              saveFeedback.push(this.saveVehicleOperationsAfterUpdate(vehicle_operations));
            }
            if (updatePricingFor.length > 0) {
              const parts = [];
              const pricingFilters = {};
              if (this.currentClaim.paint_type) {
                pricingFilters.paint_type = this.currentClaim.paint_type;
              }
              if (this.currentClaim.city_category) {
                pricingFilters.city_category = this.currentClaim.city_category;
              }
              updatePricingFor.forEach((element) => {
                const selectedPart = vehicle_operations.find(
                  (a) => a.part_name === element.part_name,
                );
                parts.push({
                  part_code: selectedPart.part_code,
                  decision: selectedPart.decision,
                  damages: selectedPart.damages,
                  internal_parts: _.map(selectedPart.smart_association_internal, (a) => _.pick(a, ['part_code', 'decision'])),
                });
              });

              const partObj = {
                claim_id: this.currentClaim.id,
                vehicle_code: this.currentClaim.vehicle_code,
                include_aux_parts: true,
                language_code: this.languageCode,
                parts,
                filters: pricingFilters,
              };
              const pricingOutput = await this.$http.post(
                '202103/pricing/part-price',
                partObj,
              );

              const allPartsUpdatedOutput = [];
              if (pricingOutput && pricingOutput.parts && pricingOutput.parts.length > 0) {
                allPartsUpdatedOutput.push(this.multiPartPricingUpdate(pricingOutput));
                await Promise.all(allPartsUpdatedOutput);
                saveFeedback.push(this.savePricingAfterUpdate(this.currentClaim.results.part_pricing));
                await Promise.all(saveFeedback);
                await this.reRunTheClaim(imageFeatures);
              }
            } else {
              // this.currentClaim.processing_completed_at = Math.random();
              // this.selectedTab = 0;
              // this.isProcessing = false;
              await this.reRunTheClaim(imageFeatures);
            }
          } else {
            // console.log('After deleting last part........................................');
          }
        }
        // if (imageFeatures.type === 'parts') {
        //   await this.reRunTheClaim(imageFeatures);
        // } else if (
        //   imageFeatures.type !== 'parts'
        //   && imageFeatures.operation === 'editFeature'
        // ) {
        //   await this.reRunTheClaim(imageFeatures);
        // } else {
        //   this.loaderText = 'Reprocessing Details';
        //   this.isProcessing = true;
        // }
        // this.isProcessing = false;
      }
    },

    async saveAnnotation1(imageFeatures) {
      // console.log('Detail Save Annotation =>', JSON.stringify(imageFeatures));
      this.selectedPartName = null;
      if (imageFeatures.type) {
        this.showLoader(imageFeatures);
        let isLastPart = false;
        let lastPartName = null;
        const allFeatures = {
          parts: 'parts',
          dent: 'dent',
          scratch: 'scratch',
          tear: 'ch',
        };
        const feat = {
          features: [],
        };
        this.showParts = false;
        const part = {};
        let damagesDeletedOn = null;
        if (imageFeatures.type !== 'parts' && imageFeatures.operation === 'removeFeature') {
          damagesDeletedOn = imageFeatures.featureId;
        }
        // Add Feature Start.
        // If imageFeatures.type is not 'Part' then we are saving all damages irrespective of the damage added.
        // If user added scratch then also we are saving Scratch, Dent and Tear polygons.
        if (
          imageFeatures.type !== 'parts'
          && imageFeatures.operation !== 'editFeature'
        ) {
          const stdModels = ['scratch', 'dent', 'tear'];
          const allSaveOps = [];
          stdModels.forEach(async (model) => {
            allSaveOps.push(
              this.saveFormatedDamagePolygons(imageFeatures, model),
            );
          });
          await Promise.all(allSaveOps);
          if (imageFeatures.operation === 'removeFeature') {
            await this.saveDeleteFeedback(imageFeatures, imageFeatures.type);
          }
        } else if (
          imageFeatures.type === 'parts'
          && imageFeatures.operation !== 'editFeature'
        ) {
          const features = imageFeatures.features.find(
            (a) => a.name === imageFeatures.type,
          );

          if (
            features.features.length === 0
            && imageFeatures.operation === 'removeFeature'
          ) {
            isLastPart = true;
            lastPartName = imageFeatures.featureId;
            this.deleteAllDamages(imageFeatures.imageId);
          }

          features.features.forEach((oneFeature) => {
            feat.features.push({
              class_id: 0,
              label:
                imageFeatures.type === 'parts'
                  ? oneFeature.meta.label
                  : allFeatures[imageFeatures.type],
              meta: oneFeature.meta,
              points: oneFeature.coordinates,
              roi: [0, 0, 0, 0],
              scores: 1,
            });

            // imageFeatures.featureId is the Id of the part which is currently added.
            // We are creating the object of newly added part so that we can add or modify the same part to rr_prediction object.
            if (oneFeature.name === imageFeatures.featureId) {
              part.part_name = oneFeature.meta.label;
              part.standard_part_name = oneFeature.meta.label;
              part.decision = oneFeature.meta.decision;
            }
          });
          await this.saveFeatures(
            imageFeatures.type,
            imageFeatures.imageId,
            feat,
          );
        } else if (
          imageFeatures.type === 'parts'
          && imageFeatures.operation === 'editFeature'
        ) {
          const features = imageFeatures.features.find(
            (a) => a.name === imageFeatures.type,
          );
          const updatedPart = _.find(
            features.features,
            (x) => x.name === imageFeatures.featureId,
          );
          this.selectedPartEdit.part_name = updatedPart.meta.label;
          this.selectedPartEdit.decision = updatedPart.meta.decision;
          // eslint-disable-next-line camelcase
          const { vehicle_operations } = this.currentClaim.results;
          const selectedPart = vehicle_operations.find(
            (a) => a.part_name === this.selectedPartEdit.part_name,
          );
          await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: this.selectedPartEdit.decision, part_name: selectedPart.name }, true);
          // await this.updatePartDecisionFromAnnotation(imageFeatures.version ? imageFeatures.version : null);
        }
        // Add Feature End.

        // If new part is added or updated (only meta can be update)
        if (
          part
          && imageFeatures.type === 'parts'
          && imageFeatures.operation === 'addFeature'
        ) {
          // Modify the 'rr_prediction' with the newly added part.
          // await this.addPart(part);
          // await this.onPartDecisionChange(part.part_name, part.decision, false);
          // eslint-disable-next-line camelcase
          const { vehicle_operations } = this.currentClaim.results;
          const selectedPart = vehicle_operations.find(
            (a) => a.part_name === part.part_name,
          );
          await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: part.decision, part_name: selectedPart.name }, true);
          // Recalculate the damage counter decision after new part gets added.
          const dt = await this.recalculateDamageCounter(
            imageFeatures.imageId,
            { isLastPart, partName: lastPartName },
          );

          // Iterate through all the parts returned by damage counter.
          // Recalculate the damage counts for the parts in rr_prediction.
          // rr_prediction damage results will be modified according to the max damage count for each part.
          if (dt && dt.partwise_damages && dt.partwise_damages.parts) {
            let cnt = 0;
            _.forEach(dt.partwise_damages.parts, async (onePart) => {
              cnt += 1;
              const updatedRRObj = await this.recalculateRRPrediction(
                imageFeatures.imageId,
                onePart,
                imageFeatures.version ? imageFeatures.version : null,
                damagesDeletedOn,
              );
              if (cnt === dt.partwise_damages.parts.length) {
                cnt += 1;
                const editRequest = {
                  feedback_type: 'rr_feedback',
                  feedback_source: 'web',
                  value: JSON.stringify(updatedRRObj),
                };
                await this.$http.post(
                  `/requests/${this.currentClaim.id}/feedback`,
                  editRequest,
                );

                this.isComponentadd = false;
                this.illustrationKey = Math.random();
                return false;
              }
              return true;
            });
            this.isComponentadd = false;
            this.illustrationKey = Math.random();
          }
        } else if (
          imageFeatures.type !== 'parts'
          && imageFeatures.operation !== 'editFeature'
        ) {
          const dt = await this.recalculateDamageCounter(
            imageFeatures.imageId,
            { isLastPart, partName: lastPartName },
          );
          let cnt1 = 0;
          if (dt && dt.partwise_damages && dt.partwise_damages.parts) {
            _.forEach(dt.partwise_damages.parts, async (onePart) => {
              cnt1 += 1;
              const updatedRRObj = await this.recalculateRRPrediction(
                imageFeatures.imageId,
                onePart,
                imageFeatures.version ? imageFeatures.version : null,
                damagesDeletedOn,
              );
              if (cnt1 === dt.partwise_damages.parts.length) {
                cnt1 += 1;
                const editRequest = {
                  feedback_type: 'rr_feedback',
                  feedback_source: 'web',
                  value: JSON.stringify(updatedRRObj),
                };
                const feedbackResponse = await this.$http.post(
                  `/requests/${this.currentClaim.id}/feedback`,
                  editRequest,
                );
                if (feedbackResponse) {
                  await this.reRunTheClaim(imageFeatures);
                }
                this.isComponentadd = false;
                this.illustrationKey = Math.random();
                return false;
              }
              return true;
            });
            this.isComponentadd = false;
            this.illustrationKey = Math.random();
          }
        } else if (
          imageFeatures.type === 'parts'
          && imageFeatures.operation === 'removeFeature'
        ) {
          // If partCount === 0 that means deleted part was only part.
          // If partCount === 0 then modify the decision against that part in rr_prediction as 'part_not_identified'
          // If partCount > 0 then recalculate the damage counts on that part.
          // If partCount > 0 decision in rr_prediction will remains same but damage counts can be modified..
          const partCount = this.verifyPart(imageFeatures.featureId);
          if (partCount === 0) {
            part.part_name = imageFeatures.featureId;
            part.standard_part_name = imageFeatures.featureId;
            part.decision = 'part_not_identified';
            part.scratch = 0;
            part.tear = 0;
            part.dent = 0;
            // await this.modifyRRPredictionCountOrDecision(
            //   part,
            //   'modify_decision',
            // );
            // eslint-disable-next-line camelcase
            const { vehicle_operations } = this.currentClaim.results;
            const selectedPart = vehicle_operations.find(
              (a) => a.part_name === part.standard_part_name,
            );
            await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: 'part_not_identified', part_name: selectedPart.name }, false);
            await this.deletePart(imageFeatures.featureId);
          } else {
            const otherDamages = this.recalculateRRDamages(
              imageFeatures.imageId,
              imageFeatures.featureId,
            );
            part.part_name = imageFeatures.featureId;
            part.standard_part_name = imageFeatures.featureId;
            part.scratch = _.max(_.map(otherDamages, 'scratch_count'));
            part.tear = _.max(_.map(otherDamages, 'tear_count'));
            part.dent = _.max(_.map(otherDamages, 'dent_count'));

            // await this.modifyRRPredictionCountOrDecision(part, 'modify_count');
            await this.updatePartDamageCount(part);
          }
          const dt = await this.recalculateDamageCounter(
            imageFeatures.imageId,
            { isLastPart, partName: lastPartName },
          );
          if (dt && dt.partwise_damages && dt.partwise_damages.parts) {
            let cnt2 = 0;
            _.forEach(dt.partwise_damages.parts, async (onePart) => {
              cnt2 += 1;
              const updatedRRObj = await this.recalculateRRPrediction(
                imageFeatures.imageId,
                onePart,
                imageFeatures.version ? imageFeatures.version : null,
                damagesDeletedOn,
              );
              if (cnt2 === dt.partwise_damages.parts.length) {
                cnt2 += 1;
                const editRequest = {
                  feedback_type: 'rr_feedback',
                  feedback_source: 'web',
                  value: JSON.stringify(updatedRRObj),
                };
                await this.$http.post(
                  `/requests/${this.currentClaim.id}/feedback`,
                  editRequest,
                );

                this.isComponentadd = false;
                this.illustrationKey = Math.random();
                return false;
              }
              return true;
            });
            this.isComponentadd = false;
            this.illustrationKey = Math.random();
          }
        }
        if (imageFeatures.type === 'parts') {
          await this.reRunTheClaim(imageFeatures);
        } else if (
          imageFeatures.type !== 'parts'
          && imageFeatures.operation === 'editFeature'
        ) {
          await this.reRunTheClaim(imageFeatures);
        } else {
          this.loaderText = 'Reprocessing Details';
          this.isProcessing = true;
        }
      }
    },

    showLoader(imageFeatures) {
      if (imageFeatures.type === 'parts'
        && imageFeatures.operation === 'addFeature') {
        this.loaderText = 'Adding Part';
        this.isProcessing = true;
      } else if (imageFeatures.type === 'parts'
        && imageFeatures.operation === 'removeFeature') {
        this.loaderText = 'Removing Part';
        this.isProcessing = true;
      } else if (imageFeatures.type === 'parts'
        && imageFeatures.operation === 'editFeature') {
        this.loaderText = 'Updating Part Decision';
        this.isProcessing = true;
      } else if (imageFeatures.type !== 'parts'
        && imageFeatures.operation === 'addFeature') {
        this.loaderText = 'Adding Damage';
        this.isProcessing = true;
      } else if (imageFeatures.type !== 'parts'
        && imageFeatures.operation === 'removeFeature') {
        this.loaderText = 'Removing Damage';
        this.isProcessing = true;
      } else if (imageFeatures.type !== 'parts'
        && imageFeatures.operation === 'editFeature') {
        this.loaderText = 'Editing Damage Severity';
        this.isProcessing = true;
      }
    },

    async saveFormatedDamagePolygons(imageFeatures, model) {
      const allFeatures = {
        parts: 'parts',
        dent: 'dent',
        scratch: 'scratch',
        tear: 'ch',
      };
      const feat1 = {
        features: [],
      };
      const features = imageFeatures.features.find((a) => a.name === model);
      if (features.features && features.features.length > 0) {
        features.features.forEach((oneFeature) => {
          feat1.features.push({
            class_id: 0,
            label:
              imageFeatures.type === 'parts'
                ? oneFeature.meta.label
                : allFeatures[model],
            meta: oneFeature.meta,
            points: oneFeature.coordinates,
            roi: [0, 0, 0, 0],
            scores: 1,
          });
        });
      }
      await this.saveFeatures(model, imageFeatures.imageId, feat1);
    },

    async saveFeatures(type, imageId, allFeatures) {
      const stdModels = {
        parts: 'parts',
        scratch: 'scratches',
        dent: 'dents',
        tear: 'tears',
      };
      // const result =
      await this.$http.post(
        `/claims/${this.currentClaim.id}/images/${imageId}/add-feature?model=${stdModels[type]}`,
        {
          polygons: allFeatures.features,
        },
      );
      // if (type === 'parts') {
      //   const image = this.currentClaim.results.images.find((a) => a.id === imageId);
      //   image.polygons.parts = result;
      // }
    },

    async saveDeleteFeedback(imageFeatures, model) {
      const allFeatures = {
        parts: 'parts',
        dent: 'dent',
        scratch: 'scratch',
        tear: 'ch',
      };
      const allPolygons = [];
      const features = imageFeatures.features.find((a) => a.name === model);
      if (features.features && features.features.length > 0) {
        features.features.forEach((oneFeature) => {
          allPolygons.push({
            class_id: 0,
            label:
              imageFeatures.type === 'parts'
                ? oneFeature.meta.label
                : allFeatures[model],
            meta: oneFeature.meta,
            points: oneFeature.coordinates,
            roi: [0, 0, 0, 0],
            scores: 1,
          });
        });
      }

      const deletedFeature = [];
      deletedFeature.push({
        class_id: 0,
        label:
          imageFeatures.polygonToBeDeleted.c_type === 'parts'
            ? imageFeatures.polygonToBeDeleted.meta.label
            : allFeatures[model],
        meta: imageFeatures.polygonToBeDeleted.meta,
        points: imageFeatures.polygonToBeDeleted.coordinates[0],
        roi: [0, 0, 0, 0],
        scores: 1,
      });
      await this.$http.post(
        `/requests/${this.currentClaim.id}/images/${imageFeatures.imageId}/feedback`,
        {
          feedback_type: `${model}_delete_feedback`,
          value: imageFeatures.delReason,
          polygons: { originalPolygons: allPolygons, deletedPolygon: deletedFeature },
        },
      );
    },

    async deleteAllDamages(imageId) {
      const stdModels = ['scratches', 'dents', 'tears'];
      stdModels.forEach(async (element) => {
        await this.$http.post(
          `/claims/${this.currentClaim.id}/images/${imageId}/add-feature?model=${element}`,
          {
            polygons: [],
          },
        );
      });
    },

    async recalculateDamageCounter(imageId, lastPartObj) {
      const { results } = this.currentClaim;
      const image = results.images.find((a) => a.id === imageId);
      const dt = await this.$http.post(
        `claims/${this.currentClaim.id}/images/${imageId}/damage-count`,
        {
          url: image.url,
          lastPart: lastPartObj,
        },
      );
      return dt;
    },

    async recalculateRRPrdiction(imageId, lastPartObj) {
      const { results } = this.currentClaim;
      const image = results.images.find((a) => a.id === imageId);
      const dt = await this.$http.post(
        `claims/${this.currentClaim.id}/images/${imageId}/rr-damages`,
        {
          url: image.url,
          lastPart: lastPartObj,
        },
      );
      return dt;
    },

    async recalculateRRPrediction(imageId, onePart, version = null, damagesDeletedOn = null) {
      const part = {};
      // otherDamages is the damage result for the part except the result on the current image id.
      const otherDamages = this.recalculateRRDamages(
        imageId,
        onePart.part_name,
      );
      // otherDamages contains all the results for the same part except on the current image id.
      // obj is the object of current result of damage counter for this particular part.
      const obj = {
        part_name: onePart.part_name,
        scratch_count: onePart.scratch_count,
        dent_count: onePart.dent_count,
        tear_count: onePart.tear_count,
      };
      otherDamages.push(obj);
      // After above line of code otherDamages contains all the updated results for the same on each image.

      // Calculate the max number of damages for the same part to update the rr_prediction for the same part.
      if (otherDamages && otherDamages.length > 0) {
        part.part_name = onePart.part_name;
        part.standard_part_name = onePart.part_name;
        part.scratch = _.max(_.map(otherDamages, 'scratch_count')) || 0;
        part.tear = _.max(_.map(otherDamages, 'tear_count')) || 0;
        part.dent = _.max(_.map(otherDamages, 'dent_count')) || 0;
        const getRRObject = await this.modifyRRPrediction(part, 'modify_count', version, damagesDeletedOn);
        return getRRObject;
      }
      return null;
    },

    async reRunTheClaim(imageFeatures) {
      this.imageIndex = imageFeatures.imageIndex;
      this.loaderText = 'Reprocessing Details';
      this.isProcessing = true;
      await this.getClaimDetails();
      this.illustrationKey = Math.random();
      this.refreshSummaryKey = Math.random();
      this.currentClaim.processing_completed_at = Math.random();
      // this.tabRefreshKey = Math.random();
      if (imageFeatures.imageId) {
        const imageInfo = this.currentClaim.results.images.find(
          (a) => a.id === imageFeatures.imageId,
        );
        const index = _.findIndex(
          this.tabData,
          (o) => o.id === imageInfo.results.position,
        );
        // this.tabRefreshKey = Math.random();
        this.currentClaim.processing_completed_at = Math.random();
        this.selectedTab = index + 1;
        this.imageIndexKey = Math.random();
      } else {
        // this.tabRefreshKey = Math.random();
        this.currentClaim.processing_completed_at = Math.random();
        this.selectedTab = 0;
      }
      this.loaderText = 'Reprocessing Details';
      this.isProcessing = false;
    },

    async updatePartDamageCount(partDetails) {
      this.loaderText = 'Reprocessing Details';
      this.isProcessing = true;
      // eslint-disable-next-line camelcase
      const { vehicle_operations } = this.currentClaim.results;
      const selectedPart = vehicle_operations.find(
        (a) => a.part_name === partDetails.part_name,
      );
      // When part is removed and the removed part is the last part then the operation === 'modify_decision'
      // Currently operation === 'modify_decision' is used when deciosn is 'part_not_identified' i.e. part removed.

      // If operation is other than 'modified_decision' (currently it is 'modify_count') then
      // change the damage counts only not the decision.

      // If operation is other than 'modified_decision' and all damage counts are zero then damages object will be empty.
      if (partDetails.scratch > 0 || partDetails.dent > 0 || partDetails.tear > 0) {
        if (
          selectedPart.decision === 'part_damage_not_identified'
          || selectedPart.decision === 'part_not_identified'
        ) {
          selectedPart.decision = 'repair';
        }
        selectedPart.damages.scratch = partDetails.scratch;
        selectedPart.damages.dent = partDetails.dent;
        selectedPart.damages.ch = partDetails.tear;
        selectedPart.damages.tear = partDetails.tear;
      }
      selectedPart.is_edited = true;
      const editRequest = {
        feedback_type: 'rr_feedback',
        feedback_source: 'web',
        value: JSON.stringify(vehicle_operations),
      };
      await this.$http.post(
        `/requests/${this.currentClaim.id}/feedback`,
        editRequest,
      );
      await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: selectedPart.decision, part_name: selectedPart.name }, false);
    },

    // This function takes imageId and PartName as argument and returns the array of
    // part and damages except the current part on current image which is provided to the function.
    // So, after this function call we get all the damage counts for the current part
    // except it returns from the damage counter

    recalculateRRDamages(imageId, partName) {
      const allSimilarParts = [];
      const { results } = this.currentClaim;
      results.images.forEach((element) => {
        if (element && element.results && element.results.part_damages && element.results.part_damages.length > 0) {
          if (element.results.is_car && element.results.is_car !== 'non_car') {
            const partFound = element.results.part_damages.find(
              (a) => a.part_name === partName,
            );
            if (partFound && element.id === imageId) {
              partFound.scratch_count = 0;
              partFound.dent_count = 0;
              partFound.tear_count = 0;
            } else if (partFound) {
              allSimilarParts.push(partFound);
            }
          }
        }
      });
      return allSimilarParts;
    },

    async modifyRRPrediction(part, operation, version = null, damagesDeletedOn = null) {
      this.loaderText = 'Reprocessing Details';
      this.isProcessing = true;
      // eslint-disable-next-line camelcase
      const { vehicle_operations } = this.currentClaim.results;
      const selectedPart = vehicle_operations.find(
        (a) => a.part_name === part.part_name,
      );
      const originalDecision = selectedPart.decision;
      // When part is removed and the removed part is the last part then the operation === 'modify_decision'
      // Currently operation === 'modify_decision' is used when deciosn is 'part_not_identified' i.e. part removed.

      // If operation is other than 'modified_decision' (currently it is 'modify_count') then
      // change the damage counts only not the decision.

      // If operation is other than 'modified_decision' and all damage counts are zero then damages object will be empty.
      if (operation === 'modify_decision') {
        selectedPart.decision = part.decision;
      } else if (part.scratch > 0 || part.dent > 0 || part.tear > 0) {
        let changeDecision = true;
        if (selectedPart && selectedPart.smart_association && selectedPart.damages) {
          const { damages } = selectedPart;
          if (part.scratch === damages.scratch && part.dent === damages.dent && part.tear === damages.tear) { changeDecision = false; }
        }
        if (changeDecision) {
          selectedPart.damages.scratch = part.scratch;
          selectedPart.damages.dent = part.dent;
          selectedPart.damages.ch = part.tear;
          selectedPart.damages.tear = part.tear;
          if (
            selectedPart.decision === 'part_damage_not_identified'
            || selectedPart.decision === 'part_not_identified'
          ) {
            selectedPart.decision = 'repair';
            if (version && version !== null && version === 'v6') {
              // await this.onPartDecisionChange(part.part_name, 'repair', true);
              await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: 'repair', part_name: selectedPart.name }, true);
            }
          }
          selectedPart.damages.scratch = part.scratch;
          selectedPart.damages.dent = part.dent;
          selectedPart.damages.ch = part.tear;
          selectedPart.damages.tear = part.tear;
        }
      } else if (!this.glassParts.includes(part.part_name) && part.part_name !== 'airbag') {
        if (damagesDeletedOn && part.part_name === damagesDeletedOn) {
          selectedPart.damages = {};
          selectedPart.decision = 'part_damage_not_identified';
          if (version && version !== null && version === 'v6') {
            if (originalDecision !== 'part_damage_not_identified') {
              // await this.updatePartPricing({ part_name: part.part_name, decision: 'part_damage_not_identified' });
              await this.updateMainPartDecision({ part_code: selectedPart.part_code, decision: 'part_damage_not_identified', part_name: selectedPart.name });
            }
            selectedPart.decision = 'part_damage_not_identified';
            selectedPart.damages = {};
          }
        }
      }
      selectedPart.is_edited = true;
      // eslint-disable-next-line camelcase
      return vehicle_operations;
    },

    // This function returns the part count by given part name from image polygon.
    // If the return count is 0, that means deleted part was the last part.

    verifyPart(partName) {
      let lblCount = 0;
      const { results } = this.currentClaim;
      results.images.forEach((element) => {
        if (element && element.results && element.part_damages && element.part_damages.length > 0) {
          if (element.results.is_car && element.results.is_car !== 'non_car') {
            const partFound = element.part_damages.filter(
              (a) => a.part_name === partName,
            );
            lblCount += partFound.length;
          }
        }
      });
      return lblCount;
    },

    async deletePart(standardPartName) {
      this.loaderText = 'Deleting Auxiliary Part';
      this.isProcessing = true;
      const pricingData = JSON.parse(
        JSON.stringify(this.currentClaim.results.part_pricing),
      );
      const pricingObj = pricingData.parts.filter(
        (dt) => dt.base_part_std_name === standardPartName,
      );
      const deletedPartData = JSON.parse(
        JSON.stringify(defaultPartObject),
      );
      deletedPartData.part_code = pricingObj.part_code;
      deletedPartData.part_name = pricingObj.part_name;
      deletedPartData.decision = 'part_not_identified';
      deletedPartData.is_deleted = true;
      await this.partPricingUpdated(deletedPartData);
      this.loaderText = 'Deleting Auxiliary Part';
      this.isProcessing = false;
      this.illustrationKey = Math.random();
    },

    // #endregion

    // #region [Reprocess Claim]

    // Sumbit claims images for reprocessing.
    async submitForReprocessing(mappedUrls) {
      this.loaderText = 'Re-submitting The Claim';
      this.isProcessing = true;
      const response = await this.$http.post(
        `claims/${this.$route.params.claimUID}/reprocess-claim`,
        {
          added: mappedUrls,
        },
      );
      if (response) {
        this.reProcessClaim();
      }
    },

    async reProcessClaim() {
      this.processPercent = 5;
      this.loaderText = 'Reprocessing Claim Request';
      this.showLink = true;
      this.progressRefreshKey = Math.random();
      this.isProcessing = true;
      // this.claimVersions = {};
      this.selectedTab = 0;
      this.fetchedClaimId = null;
      await this.getClaimDetails();
    },

    async fetchSelectedClaim(claimId) {
      this.fetchedClaimId = claimId;
      // this.claimVersions.selectedClaimId = claimId;
      this.processPercent = null;
      this.showLink = false;
      this.progressRefreshKey = Math.random();
      this.loaderText = 'Fetching Selected Version';
      this.isProcessing = true;
      this.selectedTab = 0;
      this.actionBarRefreshKey = Math.random();
      await this.getClaimDetails();
    },

    // #endregion

    // #region [Methods for handling multiple parts pricing update]
    multiPartPricingUpdate(pricingOutput) {
      if (pricingOutput && pricingOutput.parts && pricingOutput.parts.length > 0) {
        // let index = 0;
        _.forEach(pricingOutput.parts, (onePartData) => {
          // _.forEach(pricingOutput.parts, async (onePartData) => {
          // index += 1;
          const onePart = onePartData;
          // pricingOutput.parts.forEach((onePart, index) => {
          onePart.gst = this.partGstPercent;
          onePart.labour_price = this.convertTwoDecimal(((onePart.labour_rate || 0) * (onePart.labour_hours || 0)) + ((onePart.labour_rate || 0) * (onePart.dent_hours || 0)));
          onePart.paint_price = this.convertTwoDecimal(((onePart.paint_rate || 0)) + (onePart.material_cost || 0));
          onePart.part_price = this.convertTwoDecimal((((onePart.part_price || 0) * 100) / (100 + (parseFloat(this.partGstPercent)))));

          onePart.auxiliary_parts.forEach((auxElement) => {
            const auxPart = auxElement;
            // auxPart.quantity = 1;
            // auxPart.dent_hours = 0;
            auxPart.gst = this.partGstPercent;
            auxPart.labour_price = this.convertTwoDecimal(((auxPart.labour_rate || 0) * (auxPart.labour_hours || 0)) + ((auxPart.labour_rate || 0) * (auxPart.dent_hours || 0)));
            auxPart.paint_price = this.convertTwoDecimal(((auxPart.paint_rate || 0)) + (auxPart.material_cost || 0));
            auxPart.part_price = this.convertTwoDecimal((((auxPart.part_price || 0) * 100) / (100 + (parseFloat(this.partGstPercent)))));
            auxPart.meta = {
              labour_gst: this.labourTaxPercent,
              paint_gst: this.paintTaxPercent,
              total_labour_with_gst: this.convertTwoDecimal(((auxPart.labour_price || 0) + ((auxPart.labour_price || 0) * (this.labourTaxPercent / 100)))),
              total_paint_with_gst: this.convertTwoDecimal(((auxPart.paint_price || 0) + ((auxPart.paint_price || 0) * (this.paintTaxPercent / 100)))),
              total_part_with_gst: this.convertTwoDecimal((((auxPart.part_price || 0) * (auxPart.quantity || 0)) + (((auxPart.part_price || 0) * (auxPart.quantity || 0)) * (this.partGstPercent / 100)))),
            };
            auxPart.is_selected = false;
          });
          // onePart.internal_parts.forEach((intElement) => {
          _.forEach(onePart.internal_parts, async (intElement) => {
            const intPart = intElement;
            // intPart.quantity = 1;
            // intPart.dent_hours = 0;
            intPart.gst = this.partGstPercent;
            intPart.labour_price = this.convertTwoDecimal(((intPart.labour_rate || 0) * (intPart.labour_hours || 0)) + ((intPart.labour_rate || 0) * (intPart.dent_hours || 0)));
            intPart.paint_price = this.convertTwoDecimal(((intPart.paint_rate || 0)) + (intPart.material_cost || 0));
            intPart.part_price = this.convertTwoDecimal((((intPart.part_price || 0) * 100) / (100 + (parseFloat(this.partGstPercent)))));
            intPart.meta = {
              labour_gst: this.labourTaxPercent,
              paint_gst: this.paintTaxPercent,
              total_labour_with_gst: this.convertTwoDecimal(((intPart.labour_price || 0) + ((intPart.labour_price || 0) * (this.labourTaxPercent / 100)))),
              total_paint_with_gst: this.convertTwoDecimal(((intPart.paint_price || 0) + ((intPart.paint_price || 0) * (this.paintTaxPercent / 100)))),
              total_part_with_gst: this.convertTwoDecimal((((intPart.part_price || 0) * (intPart.quantity || 0)) + (((intPart.part_price || 0) * (intPart.quantity || 0)) * (this.partGstPercent / 100)))),
            };
            intPart.is_selected = false;
          });
          onePart.total_part_price = this.convertTwoDecimal(Number((onePart.part_price || 0)) + _.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.part_price || 0))));
          onePart.total_labour_price = this.convertTwoDecimal(Number((onePart.labour_price || 0)) + _.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.labour_price || 0))));
          onePart.total_paint_price = this.convertTwoDecimal(Number((onePart.paint_price || 0)) + _.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number(a.paint_price || 0)));
          onePart.meta = {
            labour_gst: this.labourTaxPercent,
            paint_gst: this.paintTaxPercent,
            total_labour_with_gst: this.convertTwoDecimal(((onePart.labour_price || 0) + ((onePart.labour_price || 0) * (this.labourTaxPercent / 100)))),
            total_paint_with_gst: this.convertTwoDecimal(((onePart.paint_price || 0) + ((onePart.paint_price || 0) * (this.paintTaxPercent / 100)))),
            total_part_with_gst: this.convertTwoDecimal((((onePart.part_price || 0) * (onePart.quantity || 0)) + (((onePart.part_price || 0) * (onePart.quantity || 0)) * (this.partGstPercent / 100)))),
            aux_parts_total_labour_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.meta.total_labour_with_gst || 0)))),
            aux_parts_total_paint_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.meta.total_paint_with_gst || 0)))),
            aux_parts_total_part_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.auxiliary_parts, ['is_selected', true]), (a) => Number((a.meta.total_part_with_gst || 0)))),
            int_parts_total_labour_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.internal_parts, ['is_selected', true]), (a) => Number((a.meta.total_labour_with_gst || 0)))),
            int_parts_total_paint_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.internal_parts, ['is_selected', true]), (a) => Number((a.meta.total_paint_with_gst || 0)))),
            int_parts_total_part_with_gst: this.convertTwoDecimal(_.sumBy(_.filter(onePart.internal_parts, ['is_selected', true]), (a) => Number((a.meta.total_part_with_gst || 0)))),
          };
          onePart.is_selected = true;
          // const reRunTheClaim = false;
          // await this.pricingSummaryUpdate(onePart, reRunTheClaim);
          this.pricingSummaryUpdate(onePart);
          this.claimInfoRefreshKey = Math.random();
          // if (index === pricingOutput.parts.length) {
          //   return true;
          // }
        });
        // return true;
        // onePart.quantity = 1;
        // onePart.dent_hours = 0;
      }
    },

    pricingSummaryUpdate(partObj) {
      if (partObj) {
        // eslint-disable-next-line no-param-reassign
        partObj.decision = partObj.decision.toLowerCase() === 'none'
          ? 'part_damage_not_identified'
          : partObj.decision;
        this.loaderText = 'Updating Part Pricing';
        this.isProcessing = true;
        const existingPartObj = this.currentClaim.results.part_pricing.parts.find((item) => item.part_code === partObj.part_code);
        const pricingSummary = this.currentClaim.results.part_pricing.summary;
        if (existingPartObj) {
          pricingSummary.total_part_price -= existingPartObj.total_part_price;
          pricingSummary.total_labour_price -= existingPartObj.total_labour_price;
          pricingSummary.total_labour_hours -= existingPartObj.total_labour_hours;
          pricingSummary.total_paint_price -= existingPartObj.total_paint_price;
          pricingSummary.total_paint_hours -= existingPartObj.total_paint_hours;

          pricingSummary.total_internal_part_price -= existingPartObj.total_internal_part_price;
          pricingSummary.total_internal_labour_price -= existingPartObj.total_internal_labour_price;
          pricingSummary.total_internal_labour_hours -= existingPartObj.total_internal_labour_hours;
          pricingSummary.total_internal_paint_price -= existingPartObj.total_internal_paint_price;
          pricingSummary.total_internal_paint_hours -= existingPartObj.total_internal_paint_hours;

          pricingSummary.total_net_price = pricingSummary.total_part_price;

          pricingSummary.meta.total_labour_with_gst -= existingPartObj.meta.total_labour_with_gst;
          pricingSummary.meta.total_paint_with_gst -= existingPartObj.meta.total_paint_with_gst;
          pricingSummary.meta.total_part_with_gst -= (existingPartObj.meta.total_part_with_gst);
          pricingSummary.meta.aux_parts_total_labour_with_gst -= existingPartObj.meta.aux_parts_total_labour_with_gst;
          pricingSummary.meta.aux_parts_total_paint_with_gst -= existingPartObj.meta.aux_parts_total_paint_with_gst;
          pricingSummary.meta.aux_parts_total_part_with_gst -= existingPartObj.meta.aux_parts_total_part_with_gst;
          pricingSummary.meta.int_parts_total_labour_with_gst -= existingPartObj.meta.int_parts_total_labour_with_gst;
          pricingSummary.meta.int_parts_total_paint_with_gst -= existingPartObj.meta.int_parts_total_paint_with_gst;
          pricingSummary.meta.int_parts_total_part_with_gst -= existingPartObj.meta.int_parts_total_part_with_gst;
        }
        const pricingObj = this.currentClaim.results.part_pricing.parts.filter((item) => item.part_code !== partObj.part_code);

        pricingSummary.total_part_price += partObj.total_part_price;
        pricingSummary.total_labour_price += partObj.total_labour_price;
        pricingSummary.total_labour_hours += partObj.total_labour_hours;
        pricingSummary.total_paint_price += partObj.total_paint_price;
        pricingSummary.total_paint_hours += partObj.total_paint_hours;

        pricingSummary.total_internal_part_price += partObj.total_internal_part_price;
        pricingSummary.total_internal_labour_price += partObj.total_internal_labour_price;
        pricingSummary.total_internal_labour_hours += partObj.total_internal_labour_hours;
        pricingSummary.total_internal_paint_price += partObj.total_internal_paint_price;
        pricingSummary.total_internal_paint_hours += partObj.total_internal_paint_hours;

        pricingSummary.total_net_price = pricingSummary.total_part_price;

        pricingSummary.meta.total_labour_with_gst += partObj.meta.total_labour_with_gst;
        pricingSummary.meta.total_paint_with_gst += partObj.meta.total_paint_with_gst;
        pricingSummary.meta.total_part_with_gst += (partObj.meta.total_part_with_gst);
        pricingSummary.meta.aux_parts_total_labour_with_gst += partObj.meta.aux_parts_total_labour_with_gst;
        pricingSummary.meta.aux_parts_total_paint_with_gst += partObj.meta.aux_parts_total_paint_with_gst;
        pricingSummary.meta.aux_parts_total_part_with_gst += partObj.meta.aux_parts_total_part_with_gst;
        pricingSummary.meta.int_parts_total_labour_with_gst += partObj.meta.int_parts_total_labour_with_gst;
        pricingSummary.meta.int_parts_total_paint_with_gst += partObj.meta.int_parts_total_paint_with_gst;
        pricingSummary.meta.int_parts_total_part_with_gst += partObj.meta.int_parts_total_part_with_gst;
        pricingSummary.is_transformed = true;

        pricingObj.push(partObj);
        this.currentClaim.results.part_pricing.parts = pricingObj;
        const selectedPart = this.currentClaim.results.vehicle_operations.find(
          (a) => a.part_code === partObj.part_code,
        );
        if (selectedPart && selectedPart.decision !== partObj.decision) {
          const repairReplacePartsExists = this.currentClaim.results.vehicle_operations.filter(
            (a) => a.decision === 'replace' || a.decision === 'repair',
          );
          if (repairReplacePartsExists.length === 1 && (partObj.decision !== 'replace' || partObj.decision !== 'repair')) {
            // eslint-disable-next-line no-param-reassign
            // reRunTheClaim = true;
          }
          if (repairReplacePartsExists.length === 0 && (partObj.decision === 'replace' || partObj.decision === 'repair')) {
            // eslint-disable-next-line no-param-reassign
            // reRunTheClaim = true; //
          }

          if (selectedPart.part_name === 'airbag') {
            // eslint-disable-next-line no-param-reassign
            // reRunTheClaim = true;
          }
          selectedPart.decision = partObj.decision;
          if (selectedPart.damages && partObj.decision === 'part_not_identified') {
            selectedPart.damages.ch = 0;
            selectedPart.damages.dent = 0;
            selectedPart.damages.scratch = 0;
            selectedPart.damages.tear = 0;
          }
          selectedPart.is_edited = true;
          // this.selectedPartDetails.decision = this.selectedPartEdit.decision;
        }
        this.claimInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
        this.currentClaim.results.repair_estimate = this.getTotalGrossRepairEstimate;
        this.currentClaim.results.repair_estimate = this.getTotalGrossRepairEstimate;
        this.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;
        this.claimInfo.totalGrossRepairEstimate = this.getTotalGrossRepairEstimate;

        // this.claimInfo.repairabilityStatus = await this.calculateRepairability();//for repairability
        // this.currentClaim.results.repairability = await this.calculateRepairability();
        // this.tabRefreshKey = Math.random();
        this.currentClaim.processing_completed_at = Math.random();
        // this.refreshSummaryKey = Math.random();
        // this.claimInfoRefreshKey = Math.random();
        // this.isProcessing = false;
        // console.log(reRunTheClaim);
      }
    },

    async saveVehicleOperationsAfterUpdate(vehicleOperations) {
      const editRequest = {
        feedback_type: 'rr_feedback',
        feedback_source: 'web',
        value: JSON.stringify(vehicleOperations),
      };
      await this.$http.post(
        `/requests/${this.currentClaim.id}/feedback`,
        editRequest,
      );
    },

    async savePricingAfterUpdate(partPricing) {
      const editRequest = {
        feedback_type: 'price_feedback',
        feedback_source: 'web',
        value: JSON.stringify(partPricing),
      };
      await this.$http.post(
        `/requests/${this.currentClaim.id}/feedback`,
        editRequest,
      );
    },
    // #endregion

    // #region get-body-type

    getBodyType() {
      let bodyType = 'sedan';
      if (this.currentClaim.body_type === 'suv') {
        bodyType = 'suv';
      } else if (this.currentClaim.body_type === 'hatchback') {
        bodyType = 'hatchback';
      } else if (this.miniVanEnabled && this.currentClaim.body_type === 'van') {
        bodyType = 'van';
      } else if (this.pickupTruckEnabled && this.currentClaim.body_type === 'pickup_truck') {
        bodyType = 'pickup_truck';
      }
      return bodyType;
    },
    // #endregion
    async showReassignPosition() {
      if (!this.isRepositionTabActive && this.rePositionImageData && this.rePositionImageData.length === 0) {
        await this.rePositionTabImageData();
      }
      // this.tabRefreshKey = Math.random();
      this.isRepositionTabActive = !this.isRepositionTabActive;
    },
    async rePositionTabImageData() {
      this.rePositionImageData = [];
      if (
        this.currentClaim
        && this.currentClaim.uid
        && this.currentClaim.results.images
      ) {
        defaultTabData = [{
          id: 'front', label: 'Front', images: [], isVisible: false,
        }, {
          id: 'front_left', label: 'Front Left', images: [], isVisible: false,
        }, {
          id: 'front_right', label: 'Front Right', images: [], isVisible: false,
        }, {
          id: 'left', label: 'Left', images: [], isVisible: false,
        }, {
          id: 'right', label: 'Right', images: [], isVisible: false,
        }, {
          id: 'rear_left', label: 'Rear Left', images: [], isVisible: false,
        }, {
          id: 'rear_right', label: 'Rear Right', images: [], isVisible: false,
        }, {
          id: 'rear', label: 'Rear', images: [], isVisible: false,
        }, {
          id: 'others', label: 'Others', images: [], isVisible: false,
        }];
        this.currentClaim.results.images.forEach((oneImage) => {
          if (oneImage && oneImage.results) {
            if (
              oneImage.results.is_car
              && oneImage.results.is_car !== 'non_car'
              && oneImage.results.position
            ) {
              const fetchedTab = defaultTabData.find(
                (pc) => pc.id === oneImage.results.position,
              );
              fetchedTab.isVisible = true;
              if (!_.find(fetchedTab.images, { id: oneImage.id })) {
                fetchedTab.images.push({
                  id: oneImage.id,
                  url: oneImage.url,
                  image_key: oneImage.key,
                  isNewlyAdded: false,
                  position: oneImage.results.position || 'others',
                  uploadedAt: this.currentClaim.processing_started_at,
                  isSelected: true,
                });
              }
            } else {
              const fetchedTab = defaultTabData.find((pc) => pc.id === 'others');
              fetchedTab.isVisible = true;
              if (!_.find(fetchedTab.images, { id: oneImage.id })) {
                fetchedTab.images.push({
                  id: oneImage.id,
                  url: oneImage.url,
                  image_key: oneImage.key,
                  isNewlyAdded: false,
                  position: oneImage.results.position || 'others',
                  uploadedAt: this.currentClaim.processing_started_at,
                  isSelected: true,
                });
              }
            }

            // remove duplicates from other-tab
            const otherTab = defaultTabData.find((pc) => pc.id === 'others');
            if (
              oneImage.results.position !== 'others'
              && oneImage.results.position
            ) {
              const posTab = defaultTabData.find(
                (pc) => pc.id === oneImage.results.position,
              );
              posTab.images.forEach((oneimg) => {
                if (_.find(otherTab.images, { id: oneimg.id })) {
                  _.remove(
                    otherTab.images,
                    _.find(otherTab.images, { id: oneimg.id }),
                  );
                }
              });
            }
            // hide other tab if no images present
            if (otherTab.images.length === 0) {
              otherTab.isVisible = false;
            }
          }
        });
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.refreshSummaryKey = Math.random();
        const defaultTabResult = defaultTabData.filter(
          (item) => item.id !== 'summary' && item.isVisible,
        );
        const tabResults = [];
        defaultTabResult.forEach((element) => {
          if (element.id !== 'others') {
            const result = this.getTabSeverityDecision(element.id);
            tabResults.push(result);
          } else {
            tabResults.push({
              position: element.id,
              repairCount: -1,
              replaceCount: -1,
            });
          }
        });

        const qa = _.sortBy(
          tabResults,
          (item) => item.replaceCount,
          (item) => item.repairCount,
        ).reverse();

        const sortedTabs = [];
        qa.forEach((element) => {
          const tab = _.filter(defaultTabData, (a) => a.id === element.position);
          const ddt = { ...tab };
          sortedTabs.push(ddt[0]);
        });
        const finalOutput = [];
        this.sequence.forEach((oneposition) => {
          const positionFound = sortedTabs.find((x) => x.id === oneposition);
          if (positionFound) {
            finalOutput.push(positionFound);
          }
        });
        this.rePositionImageData = finalOutput;
        this.cloneRePositionImageData = JSON.parse(JSON.stringify(this.rePositionImageData));
        this.refreshRepositionTabData = Math.random();
      } else {
        this.rePositionImageData = null;
        this.refreshRepositionTabData = Math.random();
      }
    },
    async validate() {
      if (this.selectedFiles && this.selectedFiles.length > 0) {
        const imageData = this.rePositionImageData.map((x) => x.images);
        const flattendImageData = _.flatten(imageData);
        if (this.selectedFiles.length + flattendImageData.length > this.maxImagesPerClaim) {
          this.selectedFiles = [];
          this.$buefy.toast.open({
            message: `Max image count per claim is ${this.maxImagesPerClaim}.`,
            type: 'is-warning',
          });
        } else {
          this.imageTempData = [];
          const addedImages = [];
          const acceptedSize = 1024 * 1024 * 10;
          for (let i = 0; i < this.selectedFiles.length; i += 1) {
            if (this.selectedFiles[i].size > acceptedSize) {
              this.$buefy.toast.open({
                message: 'Each image should be less than 10 Mb',
                type: 'is-danger',
              });
              this.selectedFiles = [];
              break;
            }
          }

          if (this.selectedFiles.length > 0) {
            this.selectedFiles.forEach((oneFile) => {
              this.imageTempData.push({
                id: Math.random(),
                url: URL.createObjectURL(oneFile),
                file: oneFile,
                image_key: null,
                isNewlyAdded: true,
                position: 'others',
                uploadedAt: new Date(),
                isSelected: true,
              });
            });
          }
          const newlyAddedImages = flattendImageData.filter((x) => x.isNewlyAdded);
          const filesMapping = newlyAddedImages.map((x) => x.file);
          if (filesMapping.length > 0) {
            this.imageTempData.forEach((oneObject) => {
              const existed = filesMapping.find((a) => a.name === oneObject.file.name);
              if (!existed) {
                addedImages.push(oneObject.file);
              }
            });
          } else {
            this.selectedFiles.forEach((element) => {
              addedImages.push(element);
            });
          }

          const uploadedImages = [];
          if (addedImages.length > 0) {
            addedImages.forEach((oneFile) => {
              uploadedImages.push({
                id: Math.random(),
                url: URL.createObjectURL(oneFile),
                file: oneFile,
                image_key: null,
                isNewlyAdded: true,
                position: 'others',
                uploadedAt: new Date(),
                isSelected: true,
              });
            });
          }
          if (addedImages.length === 0) {
            this.$buefy.toast.open({
              message: 'All the newly selected images are already added.',
              type: 'is-warning',
            });
          } else if (this.selectedFiles.length > addedImages.length) {
            this.$buefy.toast.open({
              message: 'Some of the newly selected images are already added.',
              type: 'is-warning',
            });
          }
          const formatedObject = {
            id: 'others',
            label: 'others',
            images: uploadedImages,
            isVisible: true,
            originalPosition: 'random',
          };
          await this.imagePositionChange(formatedObject);
        }
      } else {
        this.selectedFiles = [];
        this.imageTempData.forEach((oneObject) => {
          this.selectedFiles.push(oneObject.file);
        });
      }
    },
    async imagePositionChange(imageData) {
      const position = defaultTabData.find((x) => x.id === imageData.id);
      // eslint-disable-next-line no-param-reassign
      imageData.label = position.label;
      const newPositionExist = this.rePositionImageData.find((x) => x.id === imageData.id);
      if (imageData && imageData.originalPosition !== 'random') {
        const existingPositionData = this.rePositionImageData.find((x) => x.id === imageData.originalPosition);
        existingPositionData.images = existingPositionData.images.filter((x) => x.id !== imageData.images[0].id);
      }
      if (newPositionExist) {
        newPositionExist.images = _.concat(newPositionExist.images, imageData.images);
      } else {
        this.rePositionImageData.push(imageData);
      }
      const tabData = this.rePositionImageData.filter((x) => x.images.length !== 0);
      const finalOutput = [];
      const sortedPosition = [];
      this.sequence.forEach((oneposition) => {
        const positionFound = tabData.find((x) => x.id === oneposition);
        if (positionFound) {
          sortedPosition.push(oneposition);
          positionFound.images.sort((a, b) => a.id - b.id);
          finalOutput.push(positionFound);
        }
      });
      this.rePositionImageData = finalOutput;
      if (imageData.originalPosition === 'random') {
        this.selectedPositionTab = sortedPosition.length - 1;
      } else {
        const originalPositionExist = this.rePositionImageData.find((x) => x.id === imageData.originalPosition);
        if (originalPositionExist) {
          this.selectedPositionTab = sortedPosition.indexOf(imageData.originalPosition);
        } else {
          this.selectedPositionTab = sortedPosition.indexOf(imageData.id);
        }
      }
      this.checkButtonStatus();
      this.refreshRepositionTabData = Math.random();
    },
    async removeImage(imageData) {
      const existingPositionData = this.rePositionImageData.find((x) => x.id === imageData.position);
      existingPositionData.images = existingPositionData.images.filter((x) => x.id !== imageData.id);
      const tabData = this.rePositionImageData.filter((x) => x.images.length !== 0);
      const finalOutput = [];
      const sortedPosition = [];
      this.sequence.forEach((oneposition) => {
        const positionFound = tabData.find((x) => x.id === oneposition);
        if (positionFound) {
          sortedPosition.push(oneposition);
          finalOutput.push(positionFound);
        }
      });
      this.rePositionImageData = finalOutput;
      this.checkButtonStatus();
      this.refreshRepositionTabData = Math.random();
    },
    checkButtonStatus() {
      this.disableSaveReprocess = true;
      const reassifnPositionBkp = JSON.parse(JSON.stringify(this.rePositionImageData));
      const finalResult = [];
      reassifnPositionBkp.forEach((element) => {
        const elementDt = element;
        delete elementDt.originalPosition;
        if (elementDt.images && elementDt.images.length > 0) {
          elementDt.images = elementDt.images.filter((x) => x.isSelected);
        }
        if (elementDt.images.length > 0) {
          finalResult.push(elementDt);
        }
      });
      if (!_.isEqual(this.cloneRePositionImageData, finalResult)) {
        this.disableSaveReprocess = false;
      }
    },
    async processReposition() {
      if (this.rePositionImageData && this.rePositionImageData.length > 0) {
        this.uploadedNewImages = [];
        const imageData = this.rePositionImageData.map((x) => x.images);
        let flattendImageData = _.flatten(imageData);
        flattendImageData = flattendImageData.filter((x) => x.isSelected);
        if (flattendImageData && flattendImageData.length > 0) {
          this.$buefy.dialog.confirm({
            title: this.$t('confirmation_message.reprocess_claim_title'),
            message: this.$t('confirmation_message.reprocess_claim_message'),
            confirmText: this.$t('confirmation_message.reprocess_claim_confirm'),
            cancelText: this.$t('confirmation_message.Cancel'),
            type: 'is-warning',
            iconPack: 'fas',
            hasIcon: true,
            onConfirm: async () => {
              this.isProcessing = true;
              this.loaderText = 'processing-re-process-request';
              const newlyAddedImages = flattendImageData.filter((x) => x.isNewlyAdded);
              const processFunctions = [];
              if (newlyAddedImages && newlyAddedImages.length > 0) {
                this.loaderText = 'processing-new-images';
                newlyAddedImages.forEach((oneImage) => {
                  processFunctions.push(this.uploadFile(oneImage.file, oneImage.position || 'others'));
                });
                await Promise.all(processFunctions);
              }
              this.loaderText = 'formatting-data';
              const currentClaimImages = this.currentClaim.results.images.map((x) => ({
                id: x.id,
                url: x.url,
                image_key: x.image_key || null,
                position: x.results.position || 'others',
                picSubcategory: x.results.picSubcategory || null,
              }));
              const returnObject = [];
              if (flattendImageData && flattendImageData.length > 0) {
                flattendImageData.forEach((oneImage) => {
                  const imageExist = currentClaimImages.find((x) => x.id === oneImage.id);
                  if (imageExist && !oneImage.isNewlyAdded && oneImage.position !== imageExist.position) {
                    returnObject.push({
                      url: oneImage.image_key,
                      proposed_position: oneImage.position,
                    });
                  } else if (imageExist && !oneImage.isNewlyAdded) {
                    if (imageExist.position !== 'others') {
                      returnObject.push({
                        url: oneImage.image_key,
                        proposed_position: imageExist.position,
                      });
                    } else if (imageExist.picSubcategory && imageExist.picSubcategory !== 'other') {
                      returnObject.push({
                        url: oneImage.image_key,
                      });
                    } else {
                      returnObject.push({
                        url: oneImage.image_key,
                        proposed_position: imageExist.position,
                      });
                    }
                  }
                });
              }
              this.loaderText = 'sending-for-re-processing';
              const images = _.concat(this.uploadedNewImages, returnObject);
              const response = await this.$http.post(
                `claims/${this.$route.params.claimUID}/reassign-position`,
                {
                  images,
                },
              );
              if (response) {
                this.isRepositionTabActive = !this.isRepositionTabActive;
                this.rePositionImageData = [];
                this.cloneRePositionImageData = [];
                this.disableSaveReprocess = true;
                this.selectedPositionTab = 0;
                this.reProcessClaim();
              }
            },
          });
        } else {
          this.$buefy.toast.open({
            message: 'Please select at least one image for re-processing.',
            type: 'is-warning',
          });
          this.isProcessing = false;
        }
      } else {
        this.$buefy.toast.open({
          message: 'Please upload at least one image for re-processing.',
          type: 'is-warning',
        });
      }
    },
    async uploadFile(file, position) {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: localStorage.getItem('access_token'),
        },
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          console.log(percentCompleted);
        },
      };
      const payload = new FormData();
      payload.append('file', file);
      payload.append('filename', file.name);
      try {
        const result = await axios.post('/api/files/upload', payload, config);
        if (
          result
          && result.data
          && result.data.data
          && result.data.data.link
        ) {
          if (position && position !== 'others') {
            this.uploadedNewImages.push({ url: result.data.data.key, proposed_position: position });
          } else {
            this.uploadedNewImages.push({ url: result.data.data.key });
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async checkboxChange(imageData) {
      const existingPositionData = this.rePositionImageData.find((x) => x.id === imageData.position);
      const imageExist = existingPositionData.images.find((x) => x.id === imageData.id);
      imageExist.isSelected = imageData.isSelected;
      this.checkButtonStatus();
      this.refreshRepositionTabData = Math.random();
    },
    checkAndClose() {
      if (!this.disableSaveReprocess) {
        this.$buefy.dialog.confirm({
          title: this.$t('confirmation_message.discard_changes_title'),
          message: this.$t('confirmation_message.discard_changes_message'),
          confirmText: this.$t('confirmation_message.discard_changes_confirm'),
          cancelText: this.$t('confirmation_message.Cancel'),
          type: 'is-warning',
          iconPack: 'fas',
          hasIcon: true,
          onConfirm: async () => {
            this.isRepositionTabActive = !this.isRepositionTabActive;
            this.rePositionImageData = [];
            this.cloneRePositionImageData = [];
            this.disableSaveReprocess = true;
            this.selectedPositionTab = 0;
          },
        });
      } else {
        this.isRepositionTabActive = !this.isRepositionTabActive;
      }
    },

  },
};
</script>

<style>
.not-idents {
  background: #fff;
  margin-left: -21px;
  padding-left: 26px !important;
  display: inline-grid;
}

.column-equal-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.Home_link {
  color: #fff !important;
  text-decoration: underline;
}
.tab-content {
  margin-top: -9px !important;
  padding: 1rem 0rem !important;
}
.tabs.is-toggle a {
  background-color: #fff;
}
.tabs.is-toggle li.is-active a {
  background-color: #154883;
}
canvas,
.canvas-div div {
  width: 100% !important;
}
.move-right {
  margin-left: 0 auto;
}
.echart-div {
  width: 50%;
  height: 230px;
  float: left;
}
@media (max-width: 768px) {
  .viewer img {
    width: 23%;
    float: left;
    margin: 5px;
  }
}
</style>
<style>
.progress.is-orange::-webkit-progress-value {
  background-color: #f19f11;
}
.progress.is-orange::-moz-progress-bar {
  background-color: #f19f11;
}
.progress.is-orange::-ms-fill {
  background-color: #f19f11;
}
</style>
<style scoped>
.b-checkbox.checkbox {
  font-size: 10px !important;
}

.demo-wrapper {
width: 300px;
margin: -25px auto 0;
}
.html5-progress-bar {
padding:8px 15px;
border-radius: 3px;
background-color:transparent ;
box-shadow:  0px 1px 2px 0px rgba(0, 0, 0, .0);
}
.html5-progress-bar progress {
background-color: #f3f3f3;
border: 0;
width: 80%;
height: 18px;
border-radius: 9px;
}
.html5-progress-bar progress::-webkit-progress-bar {
background-color: #f3f3f3;
border-radius: 9px;
}
.html5-progress-bar progress::-webkit-progress-value {
background: rgb(28,78,128);
background: -moz-linear-gradient(90deg, rgba(28,78,128,1) 0%, rgba(28,78,128,1) 45%, rgba(3,45,87,1) 100%);
background: -webkit-linear-gradient(90deg, rgba(28,78,128,1) 0%, rgba(28,78,128,1) 45%, rgba(3,45,87,1) 100%);
background: linear-gradient(90deg, rgba(28,78,128,1) 0%, rgba(28,78,128,1) 45%, rgba(3,45,87,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1c4e80",endColorstr="#032d57",GradientType=1);
border-radius: 9px;
}
.html5-progress-bar progress::-moz-progress-bar {
background: rgb(28,78,128);
background: -moz-linear-gradient(90deg, rgba(28,78,128,1) 0%, rgba(28,78,128,1) 45%, rgba(3,45,87,1) 100%);
background: -webkit-linear-gradient(90deg, rgba(28,78,128,1) 0%, rgba(28,78,128,1) 45%, rgba(3,45,87,1) 100%);
background: linear-gradient(90deg, rgba(28,78,128,1) 0%, rgba(28,78,128,1) 45%, rgba(3,45,87,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#1c4e80",endColorstr="#032d57",GradientType=1);border-radius: 9px;
}
.html5-progress-bar .progress-value {
padding: 0px 5px;
line-height: 20px;
margin-left: 5px;
font-size: .8em; font-weight: 600;
color: #fff !important;
height: 18px;
}
</style>

<style >
.responsive-table .table-wrapper {
    max-height:80.5vh;}
</style>

<style scoped>
.gcasiagaptabs ul li a span {
  font-size: 12px;
}

</style>
<style scoped>
.responsive-table .table-wrapper {
max-height: 80.5vh;
}
.change-flow{
  display: flex; flex-direction: row-reverse;
  justify-content: flex-end;
}
.change-flow .switch.is-small{
  position:initial !important;
}
.change-flow .b-checkbox.checkbox  {
    font-size: 13px !important;
}
</style>
